// =========================================
// V10.6 — Header rétrécissement au scroll
// Toggle data-xn-scrolled passé 24px de scrollY.
// Hystérésis 8px pour éviter oscillation.
// =========================================
(function initHeaderScrub() {
  var header = document.querySelector('.xn-header');
  if (!header) return;
  var THRESHOLD_DOWN = 24;
  var THRESHOLD_UP = 16;
  var scrolled = false;
  var ticking = false;
  function update() {
    var y = window.pageYOffset || document.documentElement.scrollTop;
    if (!scrolled && y > THRESHOLD_DOWN) {
      header.setAttribute('data-xn-scrolled', 'true');
      scrolled = true;
    } else if (scrolled && y < THRESHOLD_UP) {
      header.setAttribute('data-xn-scrolled', 'false');
      scrolled = false;
    }
    ticking = false;
  }
  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }
  if (window.lenis && typeof window.lenis.on === 'function') {
    window.lenis.on('scroll', onScroll);
  } else {
    window.addEventListener('scroll', onScroll, { passive: true });
  }
  update();
})();

(function() {
  'use strict';

  function initXnovateAnimations() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      setTimeout(initXnovateAnimations, 100);
      return;
    }

    // V10: register all plugins (GSAP 3.15 ships them as globals when loaded)
    gsap.registerPlugin(ScrollTrigger);
    if (typeof SplitText !== 'undefined') gsap.registerPlugin(SplitText);
    if (typeof DrawSVGPlugin !== 'undefined') gsap.registerPlugin(DrawSVGPlugin);
    if (typeof MorphSVGPlugin !== 'undefined') gsap.registerPlugin(MorphSVGPlugin);
    if (typeof ScrambleTextPlugin !== 'undefined') gsap.registerPlugin(ScrambleTextPlugin);
    if (typeof Flip !== 'undefined') gsap.registerPlugin(Flip);

    // =========================================
    // Lenis Smooth Scroll
    // =========================================
    // V11.3.1 — chantier 3 : detection automatique du perf tier au load.
    // Avant cette V, le systeme xn-perf-lite/mid/full etait LU mais jamais SET
    // automatiquement -> tous les visiteurs (y compris mobile bas/moyen gamme)
    // etaient en mode isFull -> Lenis + 4 backdrop-filter actifs potentiellement
    // saccades. Cette fonction set la classe appropriee sur document.documentElement
    // AVANT que la logique existante (qui lit la classe) s'execute.
    function detectPerfTier() {
      var html = document.documentElement;
      // Si une classe est deja set (debug ou override Liquid), respect.
      if (html.classList.contains('xn-perf-lite') ||
          html.classList.contains('xn-perf-mid') ||
          html.classList.contains('xn-perf-full')) {
        return;
      }
      // Critere 1 : prefers-reduced-motion = lite (accessibilite + perf)
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        html.classList.add('xn-perf-lite');
        return;
      }
      // Critere 2 : deviceMemory < 2 GB = lite (appareils tres peu RAM)
      // Note : non supporte iOS Safari (undefined), donc on continue si undefined.
      var deviceMem = navigator.deviceMemory;
      if (typeof deviceMem === 'number' && deviceMem < 2) {
        html.classList.add('xn-perf-lite');
        return;
      }
      // Detection mobile (touchscreen + viewport <= 968px)
      var isMobile = window.matchMedia &&
                     window.matchMedia('(pointer: coarse) and (max-width: 968px)').matches;
      // Critere 3-4-5 : mobile -> mid par defaut, downgrade selon ressources
      if (isMobile) {
        var cores = navigator.hardwareConcurrency || 4;
        if (typeof deviceMem === 'number' && deviceMem < 4) {
          html.classList.add('xn-perf-mid');
          return;
        }
        if (cores < 4) {
          html.classList.add('xn-perf-mid');
          return;
        }
        // Mobile haute gamme = mid par defaut (downgrade prudent vs full).
        // Override manuel possible via classe Liquid ou DevTools si Osayan
        // veut tester en plein perfs sur mobile haute gamme.
        html.classList.add('xn-perf-mid');
        return;
      }
      // Desktop ou tablet pointeur fine = full
      html.classList.add('xn-perf-full');
    }
    // Execute la detection AVANT toute autre logique d'init perf tier.
    detectPerfTier();

    // Performance tier detection (logique existante V10.x conservee, lit la
    // classe set par detectPerfTier ci-dessus ou override manuel)
    var root = document.documentElement;
    var isLite = root.classList.contains('xn-perf-lite');
    var isMid = root.classList.contains('xn-perf-mid');
    var isFull = root.classList.contains('xn-perf-full');
    if (!isLite && !isMid && !isFull) {
      isFull = true;
    }

    if (typeof Lenis !== 'undefined' && !isLite) {
      var lenis = new Lenis({
        duration: 1.2,
        easing: function(t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); },
        touchMultiplier: 1.5,
        // V11.2.10 — chantier 1 : prevent handler ajoute. La directive markup
        // data-lenis-prevent-horizontal posee sur le grid Features depuis V11.2.7
        // n'etait PAS une convention native Lenis -- elle n'etait donc pas lue
        // par cette config sans handler. Cause racine partie 2 de la saccade
        // drag JS Features V11.2.7-V11.2.9 (en plus du scroll-snap CSS retire
        // au meme chantier). Handler retourne true si le node ou un ancetre
        // porte l'attribut data-lenis-prevent-horizontal, exemptant ainsi le
        // carrousel Features du smooth-scroll Lenis natif.
        prevent: function(node) {
          if (!node || typeof node.closest !== 'function') return false;
          return node.closest('[data-lenis-prevent-horizontal]') !== null;
        }
      });

      lenis.on('scroll', ScrollTrigger.update);

      gsap.ticker.add(function(time) {
        lenis.raf(time * 1000);
      });
      gsap.ticker.lagSmoothing(0);
    }

    // =========================================
    // 1. V10.8.3 — Hero home: blade G->D ~2s en sine.inOut (fluide, pas de
    // saccade) + reveal du .xn-hero__content (texte uniquement, le wireframe
    // est SORTI du masque clip-path et joue son animation V9.7 independante).
    // Approche par etat partage diagState (comme Vision V10.8.1 qui marche).
    // =========================================
    (function initHeroHomeReveal() {
      var heroSection = document.querySelector('.xn-hero');
      var headline = document.querySelector('[data-xn-hero-headline]');
      var blade = document.querySelector('.xn-hero .xn-blade');
      var tagline = document.querySelector('[data-xn-hero-tagline]');
      var ctas = document.querySelector('[data-xn-hero-ctas]');
      var content = document.querySelector('.xn-hero__content');
      if (!heroSection || !headline || !content) return;

      var supportsClipPath = (typeof CSS !== 'undefined') &&
                             CSS.supports && CSS.supports('clip-path', 'polygon(0 0, 0 0, 0 0, 0 0)');

      function forceHeroReveal() {
        if (typeof gsap === 'undefined') return;
        content.style.clipPath = 'none';
        content.style.webkitClipPath = 'none';
        gsap.set([headline, ctas, tagline].filter(Boolean), { opacity: 1, clearProps: 'transform' });
        if (tagline) tagline.classList.add('xn-hero__tagline--revealed');
      }

      if (typeof gsap === 'undefined' ||
          document.documentElement.dataset.reducedMotion === 'true' ||
          !supportsClipPath) {
        forceHeroReveal();
        return;
      }

      // Etat initial : .xn-hero__content (text+CTAs uniquement) masque par
      // clip-path collapsed a gauche. Le wireframe est en dehors du content
      // donc visible / anime independamment.
      content.style.clipPath = 'polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)';
      content.style.webkitClipPath = 'polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)';
      gsap.set([headline, ctas].filter(Boolean), { opacity: 1, clearProps: 'transform' });
      if (tagline) tagline.classList.add('xn-hero__tagline--revealed');

      if (blade && !isLite) {
        blade.style.display = 'block';
        gsap.set(blade, { opacity: 0, x: '-100%' });
      }

      function play() {
        // V10.8.3 — Approche etat partage: deux tweens paralleles avec
        // ease sine.inOut continu (pas de phases avec ease.out -> ease.in
        // qui creaient une saccade au point de jonction en V10.8.2).
        // top-right atteint 110% en 1.4s, bottom-right en 2.0s.
        // -> diagonale slash "/" haut-leading naturelle, mouvement fluide.
        var diagState = { topProgress: 0, bottomProgress: 0 };

        function applyClip() {
          var tr = 110 * diagState.topProgress;       // 0 -> 110
          var br = 110 * diagState.bottomProgress;    // 0 -> 110
          var poly = 'polygon(0% 0%, ' + tr + '% 0%, ' + br + '% 100%, 0% 100%)';
          content.style.clipPath = poly;
          content.style.webkitClipPath = poly;
        }

        // Top: avance plus rapidement (atteint 100% a t=1.4s)
        gsap.to(diagState, {
          topProgress: 1,
          duration: 1.4,
          ease: 'sine.inOut',
          onUpdate: applyClip
        });

        // Bottom: rattrape jusqu a t=2.0s (cree la diagonale haut-leading)
        gsap.to(diagState, {
          bottomProgress: 1,
          duration: 2.0,
          ease: 'sine.inOut',
          onUpdate: applyClip,
          onComplete: function () {
            content.style.clipPath = 'none';
            content.style.webkitClipPath = 'none';
          }
        });

        // Blade en parallele, meme courbe sine.inOut pour synchronie visuelle
        if (blade && !isLite) {
          gsap.to(blade, { opacity: 0.85, duration: 0.25, ease: 'sine.out' });
          gsap.to(blade, { x: '100%', duration: 2.0, ease: 'sine.inOut' });
          gsap.to(blade, { opacity: 0, duration: 0.4, delay: 1.7 });
        }
      }

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(play);
      } else {
        setTimeout(play, 200);
      }

      // Fallback timer : si l animation n a pas resolu, force le reveal final.
      setTimeout(function () {
        if (typeof gsap === 'undefined' || !content) return;
        var clip = getComputedStyle(content).clipPath || '';
        var stillClipped = clip !== 'none' && clip !== '' &&
                           gsap.getTweensOf(content).length === 0;
        if (stillClipped) {
          forceHeroReveal();
        }
      }, 3500);
    })();

    // V10.2 (FIX 23) — Vision page hero headline char-by-char reveal
    var visionHeroHeadline = document.querySelector('.xn-vision-hero__headline');
    if (visionHeroHeadline && typeof SplitText !== 'undefined' && !isLite) {
      var visionSplit = new SplitText(visionHeroHeadline, { type: 'chars,words' });
      gsap.from(visionSplit.chars, {
        opacity: 0,
        y: 24,
        duration: 0.55,
        stagger: 0.018,
        ease: 'power2.out',
        scrollTrigger: { trigger: visionHeroHeadline, start: 'top 85%', once: true }
      });
    } else if (visionHeroHeadline) {
      gsap.from(visionHeroHeadline, {
        opacity: 0, y: 30, duration: 0.9, ease: 'power3.out',
        scrollTrigger: { trigger: visionHeroHeadline, start: 'top 85%', once: true }
      });
    }

    // V10.2.1: blade sweep is now embedded in initHeroHomeReveal() above.
    // The standalone V10.1 heroBlade animation has been removed to prevent double-init.

    // Wireframe logo draw-on — welding tip v3 (synchronized timing)
    var heroWireframe = document.querySelector('.xn-hero__wireframe');
    var wireLines = document.querySelectorAll('.xn-wire-line');
    if (wireLines.length) {
      var TARGET_END = 6.3; // all lines FINISH at this time
      var TIP_LENGTH = 18;
      var LONG_THRESHOLD = 1200;
      var STAGGER = 0.06; // reduced — lines start almost together
      var MIN_DURATION = 4; // minimum draw time for any path

      var svgEl = heroWireframe ? heroWireframe.querySelector('svg') : null;

      // Measure all paths
      var lineData = [];
      wireLines.forEach(function(line) {
        var len = line.getTotalLength ? line.getTotalLength() : 200;
        lineData.push({ line: line, length: len });
      });

      // V11.3.5 — createTipClone deplacee ici (hors bloc else mode full) pour
      // permettre son appel aussi depuis isMid (mobile). Audit Osayan post V11.3.4 :
      // les "petits points lumineux qui construisent le debut de chaque ligne"
      // (V9.7) etaient absents sur mobile car le bloc isMid n'avait pas les tips.
      function createTipClone(line, len) {
        var clone = line.cloneNode(true);
        clone.classList.remove('xn-wire-line');
        clone.classList.add('xn-wire-tip');
        clone.style.strokeDasharray = TIP_LENGTH + ' ' + (len + TIP_LENGTH);
        clone.style.strokeDashoffset = len + TIP_LENGTH;
        clone.style.opacity = '1';
        clone.style.filter = 'url(#wire-glow)';
        clone.style.strokeWidth = '2.5';
        // V10.8.5 — Detection couleur source path (orange ou blanc) pour
        // colorer le tip lumineux. Supporte les 3 formats :
        //   rgba(255, 119, 0, ...) (V9.7) | #FF7700 (V10.8.5+) | FF7700.
        var stroke = (line.getAttribute('stroke') || '').toUpperCase();
        if (stroke.indexOf('255, 119, 0') !== -1 || stroke.indexOf('FF7700') !== -1) {
          clone.setAttribute('stroke', 'rgba(255, 190, 60, 0.95)');
        } else {
          clone.setAttribute('stroke', 'rgba(255, 255, 255, 0.95)');
        }
        if (svgEl) {
          var g = svgEl.querySelector('g g');
          if (g) g.appendChild(clone);
        }
        return clone;
      }

      if (isLite) {
        // Mode lite: simple fade-in, no draw-on or tips
        lineData.forEach(function(d) {
          d.line.style.strokeDasharray = 'none';
          d.line.style.strokeDashoffset = '0';
          d.line.style.opacity = '1';
        });
        if (heroWireframe) {
          // V10.8.3 — Restaure delays V9.7 (0.3s) car le wireframe est sorti
          // du clip-path masquant et joue son animation independamment.
          gsap.fromTo(heroWireframe,
            { opacity: 0 },
            { opacity: 1, duration: 1.5, delay: 0.3, ease: 'power2.out' }
          );
        }
      } else if (isMid) {
        // V11.3.5 — chantier unique : ajout tips lumineux mode mid (mobile).
        // Audit Osayan post V11.3.4 : les "petits points lumineux qui construisent
        // le debut de chaque ligne" (V9.7) sont restaures sur mobile via
        // createTipClone (anciennement disponible mode full uniquement). Variante
        // mid : 1 tip simple par path (pas le double-tip du mode full reserve aux
        // paths longs) pour economiser GPU mobile tout en preservant l'effet
        // visuel signature.
        lineData.forEach(function(d) {
          d.line.style.strokeDasharray = d.length;
          d.line.style.strokeDashoffset = d.length;
          d.line.style.opacity = '1';
          d.line.style.filter = 'none';
        });
        if (heroWireframe) {
          // V10.8.3 — Restaure delays V9.7 (0.2s) -- wireframe independant du blade.
          gsap.fromTo(heroWireframe,
            { opacity: 0 },
            { opacity: 1, duration: 2, delay: 0.2, ease: 'power2.out' }
          );
        }
        lineData.forEach(function(d, i) {
          var delay = 0.3 + i * STAGGER;
          var duration = Math.max(MIN_DURATION, TARGET_END - delay);
          gsap.to(d.line, {
            strokeDashoffset: 0,
            duration: duration,
            ease: 'power1.inOut',
            delay: delay
          });

          // V11.3.5 — chantier unique : tip simple (1 seul, pas double comme mode full)
          var tip = createTipClone(d.line, d.length);
          gsap.to(tip, {
            strokeDashoffset: TIP_LENGTH,
            duration: duration,
            ease: 'power1.inOut',
            delay: delay,
            onComplete: function() {
              gsap.to(tip, { opacity: 0, duration: 0.4, onComplete: function() {
                if (tip.parentNode) tip.parentNode.removeChild(tip);
              }});
            }
          });
        });
      } else {
        // Mode full: complete animation with tips + glow + double tip

        // Prepare main lines: visible (opacity 1) but fully masked by strokeDashoffset
        lineData.forEach(function(d) {
          d.line.style.strokeDasharray = d.length;
          d.line.style.strokeDashoffset = d.length;
          d.line.style.opacity = '1';
          d.line.style.filter = 'none';
        });

        // V11.3.5 — createTipClone() promue en closure parent au-dessus de
        // if(isLite)/else if(isMid)/else pour permettre l'usage mode mid aussi.
        // L'ancienne definition locale ici a ete supprimee (eviter duplication).

        // V10.8.3 — Restaure delays V9.7 -- wireframe independant du blade
        // (sorti du clip-path masquant), joue son animation des le chargement.
        if (heroWireframe) {
          gsap.fromTo(heroWireframe,
            { opacity: 0 },
            { opacity: 1, duration: 2, delay: 0.2, ease: 'power2.out' }
          );
        }

        // Animate each line with synchronized duration
        var totalEndTime = 0;

        lineData.forEach(function(d, i) {
          var isLong = d.length > LONG_THRESHOLD;
          var delay = 0.3 + i * STAGGER;
          var duration = Math.max(MIN_DURATION, TARGET_END - delay);

          if (isLong) {
            gsap.to(d.line, {
              strokeDashoffset: 0,
              duration: duration,
              ease: 'power1.inOut',
              delay: delay
            });

            var tip1 = createTipClone(d.line, d.length);
            gsap.to(tip1, {
              strokeDashoffset: TIP_LENGTH,
              duration: duration,
              ease: 'power1.inOut',
              delay: delay,
              onComplete: function() {
                gsap.to(tip1, { opacity: 0, duration: 0.4, onComplete: function() {
                  if (tip1.parentNode) tip1.parentNode.removeChild(tip1);
                }});
              }
            });

            var tip2 = createTipClone(d.line, d.length);
            tip2.style.strokeDashoffset = -(TIP_LENGTH);
            tip2.style.strokeDasharray = TIP_LENGTH + ' ' + (d.length + TIP_LENGTH);

            gsap.fromTo(tip2,
              { strokeDashoffset: -(TIP_LENGTH) },
              {
                strokeDashoffset: -(d.length),
                duration: duration,
                ease: 'power1.inOut',
                delay: delay,
                onComplete: function() {
                  gsap.to(tip2, { opacity: 0, duration: 0.4, onComplete: function() {
                    if (tip2.parentNode) tip2.parentNode.removeChild(tip2);
                  }});
                }
              }
            );

          } else {
            gsap.to(d.line, {
              strokeDashoffset: 0,
              duration: duration,
              ease: 'power1.inOut',
              delay: delay
            });

            var tip = createTipClone(d.line, d.length);
            gsap.to(tip, {
              strokeDashoffset: TIP_LENGTH,
              duration: duration,
              ease: 'power1.inOut',
              delay: delay,
              onComplete: function() {
                gsap.to(tip, { opacity: 0, duration: 0.4, onComplete: function() {
                  if (tip.parentNode) tip.parentNode.removeChild(tip);
                }});
              }
            });
          }

          var endTime = delay + duration + 0.4;
          if (endTime > totalEndTime) totalEndTime = endTime;
        });

        if (heroWireframe) {
          gsap.to(heroWireframe, { opacity: 1, duration: 0.5, delay: totalEndTime });
        }
      }
    }

    // =========================================
    // 2. Scroll Indicator (CSS-only glow animation)
    // =========================================

    // =========================================
    // 3. V10.1 Parallax — hero line-field / wireframe / numbers / tease-cta / keynova
    // =========================================
    if (!isLite) {
      // Line-field (subtle background grid): -8% upward
      var lineField = document.querySelector('[data-hero-linefield]');
      if (lineField) {
        gsap.to(lineField, {
          yPercent: -8,
          ease: 'none',
          scrollTrigger: {
            trigger: '.xn-hero',
            start: 'top top',
            end: 'bottom top',
            scrub: 1
          }
        });
      }

      // Wireframe: +5% downward (counter-scroll)
      var heroWire = document.querySelector('[data-hero-wireframe]');
      if (heroWire) {
        gsap.to(heroWire, {
          yPercent: 5,
          ease: 'none',
          scrollTrigger: {
            trigger: '.xn-hero',
            start: 'top top',
            end: 'bottom top',
            scrub: 1
          }
        });
      }

      // V10.2 (FIX 38) — Numbers cards: -8% (was -3%, more perceptible)
      var numbersCards = document.querySelector('[data-hero-parallax="numbers-cards"]');
      if (numbersCards) {
        gsap.to(numbersCards, {
          yPercent: -8,
          ease: 'none',
          scrollTrigger: {
            trigger: numbersCards,
            start: 'top bottom',
            end: 'bottom top',
            scrub: 1.5
          }
        });
      }

      // V10.2 (FIX 38) — Tease-CTA X deconstructed: +12% (was +6%)
      var teaseX = document.querySelector('.xn-tease-cta__x-svg');
      if (teaseX) {
        gsap.to(teaseX, {
          yPercent: 12,
          ease: 'none',
          scrollTrigger: {
            trigger: '.xn-tease-cta',
            start: 'top bottom',
            end: 'bottom top',
            scrub: 2
          }
        });
      }

      // Keynova card image: slight zoom-out 1.08 → 1.00 on scroll
      var keynovaImg = document.querySelector('.xn-keynova-card__image, [data-keynova-parallax]');
      if (keynovaImg) {
        gsap.fromTo(keynovaImg, {
          scale: 1.08
        }, {
          scale: 1,
          ease: 'none',
          scrollTrigger: {
            trigger: keynovaImg,
            start: 'top bottom',
            end: 'bottom top',
            scrub: 1.5
          }
        });
      }
    }


    // =========================================
    // 4b. V10 Mobile Menu Toggle
    // =========================================
    var mobileToggle = document.querySelector('[data-xn-mobile-toggle]');
    var mobileMenu = document.querySelector('[data-xn-mobile-menu]');
    if (mobileToggle && mobileMenu) {
      function closeMobileMenu() {
        mobileMenu.dataset.open = 'false';
        mobileMenu.setAttribute('aria-hidden', 'true');
        mobileToggle.setAttribute('aria-expanded', 'false');
        mobileToggle.setAttribute('aria-label', 'Ouvrir le menu');
        document.body.style.overflow = '';
      }
      function openMobileMenu() {
        mobileMenu.dataset.open = 'true';
        mobileMenu.setAttribute('aria-hidden', 'false');
        mobileToggle.setAttribute('aria-expanded', 'true');
        mobileToggle.setAttribute('aria-label', 'Fermer le menu');
        document.body.style.overflow = 'hidden';
      }
      mobileToggle.addEventListener('click', function () {
        if (mobileMenu.dataset.open === 'true') closeMobileMenu();
        else openMobileMenu();
      });
      document.querySelectorAll('[data-xn-mobile-close]').forEach(function (el) {
        el.addEventListener('click', closeMobileMenu);
      });
      mobileMenu.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', closeMobileMenu);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && mobileMenu.dataset.open === 'true') closeMobileMenu();
      });
    }

    // =========================================
    // 6. General Reveal Animations — robust (V10.2)
    // Fixes V10.1 bug : 22/22 elements stuck at opacity:0 because gsap.from
    // with default immediateRender=true sets opacity:0 immediately, then
    // ScrollTrigger 'top 80%' never fires for elements already past that mark.
    // V10.2 : explicit gsap.set initial state + dynamic in-viewport check at boot
    // + explicit ScrollTrigger.create() with onEnter only for off-screen elements
    // + safety net (4s) forcing visibility on any [data-reveal] still at opacity:0.
    // =========================================
    (function initReveals() {
      var reveals = document.querySelectorAll('[data-reveal]');
      if (!reveals.length) return;

      reveals.forEach(function(el) {
        gsap.set(el, { opacity: 0, y: 60 });

        var rect = el.getBoundingClientRect();
        var alreadyVisible = rect.top < window.innerHeight * 0.9;

        if (alreadyVisible) {
          gsap.to(el, {
            opacity: 1,
            y: 0,
            duration: 0.8,
            ease: 'power2.out',
            delay: 0.2
          });
        } else {
          ScrollTrigger.create({
            trigger: el,
            start: 'top 90%',
            once: true,
            onEnter: function() {
              gsap.to(el, {
                opacity: 1,
                y: 0,
                duration: 0.8,
                ease: 'power2.out'
              });
            }
          });
        }
      });

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function() { ScrollTrigger.refresh(); });
      }

      // Safety net : after 4s, force any still-hidden [data-reveal] to visible
      setTimeout(function() {
        document.querySelectorAll('[data-reveal]').forEach(function(el) {
          if (parseFloat(getComputedStyle(el).opacity) < 0.1) {
            gsap.set(el, { opacity: 1, y: 0 });
          }
        });
      }, 4000);
    })();

    // =========================================
    // 7. Gap Section - Orange Line Scrub
    // =========================================
    var gapLine = document.querySelector('[data-gap-line]');
    if (gapLine) {
      gsap.to(gapLine, {
        scaleY: 1,
        ease: 'none',
        scrollTrigger: {
          trigger: '.xn-gap__content',
          start: 'top 80%',
          end: 'bottom 20%',
          scrub: 0.5
        }
      });
    }

    // =========================================
    // 8. Counter Animations
    // =========================================
    var counters = document.querySelectorAll('[data-counter]');
    counters.forEach(function(el) {
      var target = parseFloat(el.getAttribute('data-counter'));
      var decimals = parseInt(el.getAttribute('data-decimals') || '0', 10);
      var obj = { val: 0 };

      gsap.to(obj, {
        val: target,
        duration: 2,
        ease: 'power2.out',
        snap: decimals === 0 ? { val: 1 } : {},
        scrollTrigger: {
          trigger: el,
          start: 'top 80%',
          toggleActions: 'play none none none'
        },
        onUpdate: function() {
          var formatted = decimals > 0 ? obj.val.toFixed(decimals) : String(Math.round(obj.val));
          el.textContent = formatted.replace('.', ',');
        }
      });
    });

    // =========================================
    // 8b. Friction Chart Bar Animation
    // =========================================
    var frictionBars = document.querySelectorAll('[data-bar-width]');
    if (frictionBars.length) {
      frictionBars.forEach(function(bar) {
        var targetWidth = bar.getAttribute('data-bar-width') + '%';
        ScrollTrigger.create({
          trigger: bar,
          start: 'top 85%',
          onEnter: function() {
            bar.style.width = targetWidth;
          },
          once: true
        });
      });
    }

    // =========================================
    // 9. Proof Image Parallax
    // =========================================
    var proofImage = document.querySelector('[data-proof-image]');
    if (proofImage && !isLite) {
      gsap.to(proofImage, {
        y: '-20%',
        ease: 'none',
        scrollTrigger: {
          trigger: proofImage,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true
        }
      });
    }

    // =========================================
    // 9b. Proof Image Tilt — react to mouse anywhere on screen when visible
    // =========================================
    var proofWrap = document.querySelector('.xn-proof__image-wrap');
    var proofImg = document.querySelector('.xn-proof__image');
    if (proofWrap && proofImg && window.matchMedia('(pointer: fine)').matches) {
      var isProofVisible = false;

      ScrollTrigger.create({
        trigger: proofWrap,
        start: 'top 90%',
        end: 'bottom 10%',
        onEnter: function() { isProofVisible = true; },
        onLeave: function() { isProofVisible = false; proofImg.style.transform = ''; },
        onEnterBack: function() { isProofVisible = true; },
        onLeaveBack: function() { isProofVisible = false; proofImg.style.transform = ''; }
      });

      document.addEventListener('mousemove', function(e) {
        if (!isProofVisible) return;
        var rect = proofWrap.getBoundingClientRect();
        var centerX = rect.left + rect.width / 2;
        var centerY = rect.top + rect.height / 2;
        var x = (e.clientX - centerX) / (window.innerWidth / 2);
        var y = (e.clientY - centerY) / (window.innerHeight / 2);
        x = Math.max(-1, Math.min(1, x));
        y = Math.max(-1, Math.min(1, y));
        proofImg.style.transform = 'rotateY(' + (x * 8) + 'deg) rotateX(' + (-y * 5) + 'deg) scale(1.02)';
      });
    }

    // =========================================
    // 10. Founder Section
    // V10.2 : data-founder-mark removed (FIX 10 — decorative quote-mark deleted)
    // =========================================
    var founderQuote = document.querySelector('[data-founder-quote]');
    if (founderQuote && typeof SplitText !== 'undefined' && !isLite) {
      var quoteSplit = new SplitText(founderQuote, { type: 'lines' });
      gsap.from(quoteSplit.lines, {
        opacity: 0,
        y: 30,
        duration: 0.6,
        stagger: 0.15,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: founderQuote,
          start: 'top 75%',
          toggleActions: 'play none none none'
        }
      });
    } else if (founderQuote) {
      gsap.from(founderQuote, { opacity: 0, y: 40, duration: 1, ease: 'power3.out',
        scrollTrigger: { trigger: founderQuote, start: 'top 75%', toggleActions: 'play none none none' }
      });
    }

    // V10.1: founder attribution fade-in (was [data-founder-sig])
    // V12.9.1 (CP2) : .xn-founder__attribution retire du selecteur (markup supprime).
    var founderAttribution = document.querySelectorAll('.xn-vision-founder__sub');
    founderAttribution.forEach(function(attr) {
      gsap.from(attr, {
        opacity: 0,
        y: 12,
        duration: 0.6,
        delay: 0.4,
        scrollTrigger: {
          trigger: attr,
          start: 'top 85%',
          toggleActions: 'play none none none'
        }
      });
    });

    // V12.9.1 (CP2) — IIFE initSignatureReveal + initSignatureFallback retirees.
    // La signature manuscrite du founder est supprimee (decision Osayan).
    // Selecteur [data-founder-signature] et classe .xn-signature--revealed
    // n'existent plus dans le markup ni dans le CSS.

    // =========================================
    // 10c. V10.2 — Coming Soon timeline in-view (FIX 30)
    // Triggers .is-in-view on ol[data-cs-timeline] to draw the vertical orange→border line.
    // =========================================
    (function initCsTimeline() {
      var lists = document.querySelectorAll('[data-cs-timeline]');
      if (!lists.length) return;
      if (!('IntersectionObserver' in window)) {
        lists.forEach(function(l) { l.classList.add('is-in-view'); });
        return;
      }
      var obs = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in-view');
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.2 });
      lists.forEach(function(l) { obs.observe(l); });
    })();

    // =========================================
    // 10b. V10.2 — Vision section in-view trigger (FIX 9)
    // Toggles .is-in-view on the vision section to draw the asymmetric underline
    // beneath the H2 lead.
    // =========================================
    (function initVisionInView() {
      var visionSections = document.querySelectorAll('[data-xn-section="vision"], [data-vision-hero]');
      if (!visionSections.length) return;
      if (!('IntersectionObserver' in window)) {
        visionSections.forEach(function(s) { s.classList.add('is-in-view'); });
        return;
      }
      var obs = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in-view');
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.25 });
      visionSections.forEach(function(s) { obs.observe(s); });
    })();

    // =========================================
    // 11. Orange Divider Scrub
    // =========================================
    var dividerOrange = document.querySelector('[data-divider-orange]');
    if (dividerOrange) {
      gsap.to(dividerOrange, {
        scaleX: 1,
        ease: 'none',
        scrollTrigger: {
          trigger: dividerOrange,
          start: 'top 80%',
          end: 'top 30%',
          scrub: 0.5
        }
      });
    }

    // =========================================
    // 12. Tease Section - X SVG Draw-on
    // =========================================
    var xLines = document.querySelectorAll('.xn-x-line');

    if (xLines.length) {
      xLines.forEach(function(line) {
        var length = line.getTotalLength ? line.getTotalLength() : 200;
        line.style.strokeDasharray = length;
        line.style.strokeDashoffset = length;
      });

      gsap.to(xLines, {
        strokeDashoffset: 0,
        duration: 1.4,
        stagger: 0.35,
        ease: 'power2.inOut',
        scrollTrigger: {
          trigger: '[data-x-svg]',
          start: 'top 70%',
          toggleActions: 'play none none none'
        }
      });
    }

    // =========================================
    // 13. Tease Title - Word Reveal
    // V10.7.0 — FIX 3.3 : sécurité scroll rapide.
    // Sur scroll rapide, ScrollTrigger fire l'enter mais les frames GSAP n'ont
    // pas le temps de compléter avant la sortie viewport → titres figés à
    // mi-animation (opacity ~0.3). Ajout onLeave/onLeaveBack qui force l'état
    // final + safety net 3s sur la section complète.
    // =========================================
    var teaseTitle = document.querySelector('[data-tease-title]');
    var teaseSection = document.querySelector('.xn-tease-cta');
    if (teaseTitle && typeof SplitText !== 'undefined' && !isLite) {
      var teaseSplit = new SplitText(teaseTitle, { type: 'words' });
      gsap.from(teaseSplit.words, {
        opacity: 0,
        y: 30,
        duration: 0.6,
        stagger: 0.08,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: teaseTitle,
          start: 'top 80%',
          toggleActions: 'play none none none',
          onLeave: function () { gsap.set(teaseSplit.words, { opacity: 1, y: 0 }); },
          onLeaveBack: function () { gsap.set(teaseSplit.words, { opacity: 1, y: 0 }); }
        }
      });
    } else if (teaseTitle) {
      gsap.from(teaseTitle, { opacity: 0, y: 40, duration: 1, ease: 'power3.out',
        scrollTrigger: {
          trigger: teaseTitle,
          start: 'top 80%',
          toggleActions: 'play none none none',
          onLeave: function () { gsap.set(teaseTitle, { opacity: 1, y: 0 }); },
          onLeaveBack: function () { gsap.set(teaseTitle, { opacity: 1, y: 0 }); }
        }
      });
    }
    // V10.7.0 — FIX 3.3 (safety net section) : si l'utilisateur scrolle vite,
    // forcer tous les éléments visibles dans .xn-tease-cta après 3s.
    if (teaseSection) {
      ScrollTrigger.create({
        trigger: teaseSection,
        start: 'top center',
        once: true,
        onEnter: function () {
          setTimeout(function () {
            teaseSection.querySelectorAll('[data-reveal], [data-tease-title]').forEach(function (el) {
              if (parseFloat(getComputedStyle(el).opacity) < 0.95) {
                gsap.set(el, { opacity: 1, y: 0 });
              }
            });
            // Words SplitText : force visibilité finale
            teaseSection.querySelectorAll('[data-tease-title] > div, [data-tease-title] span').forEach(function (w) {
              gsap.set(w, { opacity: 1, y: 0 });
            });
          }, 3000);
        }
      });
    }

    // =========================================
    // 14. Redacted Micro-Glitch
    // =========================================
    var blurEls = document.querySelectorAll('.xn-blur');
    if (blurEls.length && !isLite) {
      function glitch() {
        gsap.to(blurEls, {
          x: function() { return gsap.utils.random(-1, 1); },
          opacity: function() { return gsap.utils.random(0.8, 1); },
          duration: 0.05,
          repeat: 3,
          yoyo: true,
          ease: 'none'
        });
      }
      setInterval(glitch, 8000);
    }

    // =========================================
    // 15. Countdown Timer
    // =========================================
    var countdownContainer = document.querySelector('[data-countdown-target]');
    if (countdownContainer) {
      var targetDate = new Date(countdownContainer.getAttribute('data-countdown-target')).getTime();
      var daysEl = countdownContainer.querySelector('[data-countdown="days"]');
      var hoursEl = countdownContainer.querySelector('[data-countdown="hours"]');
      var minutesEl = countdownContainer.querySelector('[data-countdown="minutes"]');
      var secondsEl = countdownContainer.querySelector('[data-countdown="seconds"]');

      function updateCountdown() {
        var now = Date.now();
        var diff = targetDate - now;

        if (diff <= 0) {
          if (daysEl) daysEl.textContent = '00';
          if (hoursEl) hoursEl.textContent = '00';
          if (minutesEl) minutesEl.textContent = '00';
          if (secondsEl) secondsEl.textContent = '00';
          return;
        }

        var days = Math.floor(diff / (1000 * 60 * 60 * 24));
        var hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((diff % (1000 * 60)) / 1000);

        // V12.9.0 (CP6) — days pad a 2 chiffres (00-99) pour coherence avec les
        // autres unites. Au-dela de 99 jours, affichage de la valeur reelle sans
        // pad parasite (padStart 2 ne tronque jamais, donc 100/365 s'affichent
        // entiers). Avant : padStart(3, '0') produisait '099' a 99 jours.
        if (daysEl) daysEl.textContent = String(days).padStart(2, '0');
        if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
        if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, '0');
        if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, '0');
      }

      updateCountdown();
      setInterval(updateCountdown, 1000);
    }

    // =========================================
    // 16. Custom Cursor (desktop only)
    // =========================================
    var cursor = document.querySelector('.xn-cursor');
    if (cursor && window.matchMedia('(pointer: fine)').matches) {
      var xTo = gsap.quickTo(cursor, 'left', { duration: 0.3, ease: 'power3' });
      var yTo = gsap.quickTo(cursor, 'top', { duration: 0.3, ease: 'power3' });

      document.addEventListener('mousemove', function(e) {
        cursor.classList.add('xn-cursor--active');
        xTo(e.clientX);
        yTo(e.clientY);
      });

      document.addEventListener('mouseleave', function() {
        cursor.classList.remove('xn-cursor--active');
      });

      // Grow on interactive elements
      var interactives = document.querySelectorAll('a, button, input, textarea, [role="button"]');
      interactives.forEach(function(el) {
        el.addEventListener('mouseenter', function() {
          cursor.classList.add('xn-cursor--hover');
        });
        el.addEventListener('mouseleave', function() {
          cursor.classList.remove('xn-cursor--hover');
        });
      });

      // Tease section: crosshair mode
      var teaseSection = document.querySelector('.xn-tease');
      if (teaseSection) {
        teaseSection.addEventListener('mouseenter', function() {
          cursor.classList.add('xn-cursor--tease');
        });
        teaseSection.addEventListener('mouseleave', function() {
          cursor.classList.remove('xn-cursor--tease');
        });
      }

      // Section-based cursor states
      var heroSection = document.querySelector('.xn-hero');
      var proofSection = document.querySelector('.xn-proof');

      if (heroSection) {
        heroSection.addEventListener('mouseenter', function() { cursor.classList.add('xn-cursor--hero'); });
        heroSection.addEventListener('mouseleave', function() { cursor.classList.remove('xn-cursor--hero'); });
      }
      if (proofSection) {
        proofSection.addEventListener('mouseenter', function() { cursor.classList.add('xn-cursor--proof'); });
        proofSection.addEventListener('mouseleave', function() { cursor.classList.remove('xn-cursor--proof'); });
      }
    }

    // =========================================
    // 17. Cookie Preference Button Fallback
    // =========================================
    var cookieBtn = document.querySelector('[data-cookie-btn]');
    if (cookieBtn) {
      cookieBtn.addEventListener('click', function() {
        if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.showBanner === 'function') {
          window.Shopify.customerPrivacy.showBanner();
        } else {
          alert('Les préférences cookies ne sont pas disponibles en mode preview. Elles fonctionneront sur le site publié.');
        }
      });
    }

    // =========================================
    // V10 SIGNATURE MOMENTS — delegated to signature-moments.js
    // =========================================
    if (typeof window.initXnovateSignatureMoments === 'function') {
      try { window.initXnovateSignatureMoments(); } catch (e) { console.warn('[xn] signature-moments init', e); }
    }

    // =========================================
    // FINAL: Force ScrollTrigger to recalculate positions
    // Fixes: header size, reveal timing, overflow calculation
    // Runs after a short delay to let Lenis calculate content height
    // =========================================
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        ScrollTrigger.refresh();
      });
    });
  }

  // Launch AFTER fonts, images, and layout are ready
  function safeInit() {
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function() {
        initXnovateAnimations();
      });
    } else {
      initXnovateAnimations();
    }
  }

  // --- Auto-scroll to form success message ---
  var formSuccess = document.querySelector('[data-form-success]');
  if (formSuccess) {
    formSuccess.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  if (document.readyState === 'complete') {
    safeInit();
  } else {
    window.addEventListener('load', safeInit);
  }
})();


// V12.9.1 (CP2) — Notes historiques liees a la signature manuscrite du founder
// retirees (signature supprimee definitivement, decision Osayan).

/* ============================================================
   V10.6 LOT 2 — DESIGNER : IIFEs profondeur + rupture
   ============================================================ */

// V10.7.1 — FIX 1.3 : Parallaxe hero-grid désactivée. La grille est désormais
//                     fournie par .xn-page-grid global en position fixed = parallaxe naturel,
//                     plus besoin de tween JS. Bloc conservé pour compat (no-op si data-hero-grid absent).
(function initHeroGridParallax() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var grid = document.querySelector('[data-hero-grid]');
  var hero = document.querySelector('.xn-hero');
  if (!grid || !hero) return;   // V10.7.1 : data-hero-grid retiré du HTML, ce return s'exécute → no-op.
  gsap.to(grid, {
    y: -180, ease: 'none',
    scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: 0.8 }
  });
})();

// V10.8.1 (CP-C) — Vision rupture: revelation par clip-path, fluidifiee +
// rallongee. La V10.8 etait saccadee (timeline 2 phases avec ease.out -> ease.in
// brutal). Refonte avec timeline UNIQUE en ease "sine.inOut" sur 2.4s pour
// un mouvement continu et homogene.
(function initVisionBlade() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  var blades = document.querySelectorAll('[data-vision-blade]');
  if (!blades.length) return;

  var prefersReduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var supportsClipPath = (typeof CSS !== 'undefined') &&
                         CSS.supports && CSS.supports('clip-path', 'polygon(0 0, 0 0, 0 0, 0 0)');

  blades.forEach(function (blade) {
    var wrapper = blade.parentElement;
    if (!wrapper) return;

    // Reduced motion ou pas de support clip-path : tout visible immediatement.
    if (prefersReduce || !supportsClipPath) {
      wrapper.style.clipPath = 'none';
      blade.style.opacity = '0';
      return;
    }

    // Etat initial : wrapper masque (polygon collapsed sur le bord droit).
    wrapper.style.clipPath = 'polygon(100% 0%, 100% 0%, 100% 100%, 100% 100%)';
    wrapper.style.webkitClipPath = 'polygon(100% 0%, 100% 0%, 100% 100%, 100% 100%)';

    ScrollTrigger.create({
      trigger: wrapper,
      start: 'top 70%',
      once: true,
      onEnter: function () {
        // V10.8.1 — Timeline unique 2.4s avec ease sine.inOut pour fluidite.
        // L effet diagonal "haut-leading / bas-trailing" est obtenu via deux
        // tweens paralleles avec offsets temporels (top atteint -10% a 1.6s,
        // bottom seulement a 2.4s -> diagonale visible).
        var diagState = { topProgress: 0, bottomProgress: 0 };

        function applyClip() {
          var tl = 100 - 110 * diagState.topProgress;     // 100 -> -10
          var br = 100 - 110 * diagState.topProgress;     // 100 -> -10 (top-right symetrique)
          var bl = 100 - 110 * diagState.bottomProgress;  // 100 -> -10
          var poly = 'polygon(' + tl + '% 0%, 100% 0%, 100% 100%, ' + bl + '% 100%)';
          wrapper.style.clipPath = poly;
          wrapper.style.webkitClipPath = poly;
        }

        gsap.to(diagState, {
          topProgress: 1,
          duration: 1.6,
          ease: 'sine.inOut',
          onUpdate: applyClip
        });

        gsap.to(diagState, {
          bottomProgress: 1,
          duration: 2.4,
          ease: 'sine.inOut',
          onUpdate: applyClip,
          onComplete: function () {
            // Une fois entierement revele, on retire le clip-path.
            wrapper.style.clipPath = 'none';
            wrapper.style.webkitClipPath = 'none';
          }
        });

        // Le blade orange suit la diagonale (skewX(22deg) cree le tilt visuel).
        gsap.fromTo(blade,
          { x: '100%', opacity: 0 },
          {
            x: '-100%',
            opacity: 1,
            duration: 2.4,
            ease: 'sine.inOut',
            onComplete: function () {
              gsap.to(blade, { opacity: 0, duration: 0.6 });
            }
          }
        );
      }
    });
  });
})();

// V10.6 — Friction bars animation (Task 3)
(function initFrictionBars() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  var bars = document.querySelectorAll('.xn-friction-bar__fill[data-bar-width]');
  if (!bars.length) return;
  bars.forEach(function(bar) {
    var target = parseFloat(bar.dataset.barWidth) || 0;
    gsap.to(bar, {
      width: target + '%', duration: 1.2, ease: 'power3.out',
      scrollTrigger: { trigger: bar.closest('.xn-friction-chart') || bar, start: 'top 75%', once: true }
    });
  });
})();

// V10.6 — Rupture orange : trigger blade reveal au scroll-in (Task 6D)
(function initRuptureReveal() {
  var ruptures = document.querySelectorAll('[data-xn-rupture]');
  if (!ruptures.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    ruptures.forEach(function(r) { r.classList.add('is-revealed'); });
    return;
  }
  if (!('IntersectionObserver' in window)) {
    ruptures.forEach(function(r) { r.classList.add('is-revealed'); });
    return;
  }
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting && entry.intersectionRatio >= 0.20) {
        setTimeout(function() { entry.target.classList.add('is-revealed'); }, 120);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: [0, 0.10, 0.20, 0.40] });
  ruptures.forEach(function(r) { observer.observe(r); });
  setTimeout(function() {
    document.querySelectorAll('[data-xn-rupture]:not(.is-revealed)').forEach(function(r) { r.classList.add('is-revealed'); });
  }, 5000);
})();

// =================================================================
// V11.0.1 — CTA persistant homepage : show/hide via IntersectionObserver
// Plus robuste que ScrollTrigger en combinaison avec Lenis smooth scroll.
// Visible apres la fin du hero, masque quand tease-cta entre en viewport.
// Reduced-motion : CSS-driven (transition: none), pas de logique JS specifique.
// =================================================================
(function initCtaPersistent() {
  var ctaEl = document.querySelector('[data-cta-persistent]');
  if (!ctaEl) return; // snippet absent (pages hors homepage)

  var heroEl = document.querySelector('.xn-hero');
  var teaseCtaEl = document.querySelector('#xn-tease-cta');
  if (!heroEl || !teaseCtaEl) return;

  // V14.1.2 (§2.1) — logique POSITIONNELLE REVERSIBLE. Remplace le latch
  // permanent V14 (hasReachedTease) qui eteignait le bandeau definitivement des
  // le 1er contact avec tease-cta. Le bandeau est visible UNIQUEMENT dans la
  // zone de lecture : sous le hero ET au-dessus de la section de fin
  // (#xn-tease-cta). Quand le haut de la section de fin atteint le bas du
  // viewport — puis le footer, situe en dessous — on masque. En REMONTANT, la
  // condition redevient vraie et le bandeau reapparait. Aucun flag permanent :
  // on relit la position reelle a chaque bascule (cf. teaseObserver).
  var heroInView = true;

  function inReadingZone() {
    // true tant que la section de fin est entierement SOUS le viewport (on est
    // donc encore dans la zone de lecture intermediaire). Couvre le footer : une
    // fois tease-cta franchie, son top reste <= innerHeight (puis negatif).
    return teaseCtaEl.getBoundingClientRect().top > window.innerHeight;
  }

  function syncCtaState() {
    var shouldShow = !heroInView && inReadingZone();
    if (shouldShow) {
      ctaEl.classList.add('is-visible');
      ctaEl.setAttribute('aria-hidden', 'false');
    } else {
      ctaEl.classList.remove('is-visible');
      ctaEl.setAttribute('aria-hidden', 'true');
    }
  }

  // Observer hero : detecte si le hero est encore visible dans le viewport
  var heroObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      heroInView = entry.isIntersecting;
      syncCtaState();
    });
  }, {
    root: null,
    rootMargin: '0px',
    threshold: 0
  });
  heroObserver.observe(heroEl);

  // Observer la section de fin : ses bascules d'intersection (entree par le bas
  // en descendant, sortie par le bas en remontant) coincident avec celles de
  // inReadingZone() — on recalcule la position reelle a chaque bascule, donc le
  // bandeau revient correctement quand on remonte dans la zone de lecture.
  var teaseObserver = new IntersectionObserver(function() {
    syncCtaState();
  }, {
    root: null,
    rootMargin: '0px',
    threshold: 0
  });
  teaseObserver.observe(teaseCtaEl);

  // Etat initial : on lance un check au load une fois les observers attaches
  syncCtaState();
})();


/* === V12.1 VISION VISUEL ===================================================
   Effets scopés à la page Vision (/pages/vision). Fonction AJOUTÉE en fin de
   fichier, dans le même flux d'init que les autres IIFE top-level. Ne modifie
   ni initReveals, ni initSignatureReveal, ni le countdown, ni les fonctions
   produit/home. No-op hors page Vision (garde .xn-vision-hero) — protège la
   homepage, qui partage le hook [data-vision-blade].
   (1) Filets / marqueurs de construction : reveal CSS-driven via la classe
       .is-traced posée par IntersectionObserver. Dégrade seul (reduced-motion
       et tier lite gérés en CSS ; fallback si pas d'IntersectionObserver ;
       filet de sécurité 4 s).
   (2) Accroches thèse + CTA composées mot-à-mot via SplitText (pattern du bloc
       tease home). Repli en fondu simple si SplitText absent, tier lite ou
       reduced-motion ; onLeave/onLeaveBack + filet de sécurité 4 s.
   ========================================================================== */
(function initVisionV121() {
  var hero = document.querySelector('.xn-vision-hero');
  if (!hero) return;                                   // hors page Vision : no-op
  var docEl = document.documentElement;
  if (docEl.getAttribute('data-vision-v121') === 'on') return;  // idempotence
  docEl.setAttribute('data-vision-v121', 'on');

  var isLite = docEl.classList.contains('xn-perf-lite');
  var prefersReduce = !!(window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  // ---- (1) Filets & marqueurs de construction (animation gérée en CSS) ----
  var fxEls = document.querySelectorAll('[data-vision-fx]');
  function traceAll() {
    fxEls.forEach(function (el) { el.classList.add('is-traced'); });
  }
  if (fxEls.length) {
    if (!('IntersectionObserver' in window)) {
      traceAll();
    } else {
      var fxObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-traced');
            fxObs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });
      fxEls.forEach(function (el) { fxObs.observe(el); });
      setTimeout(traceAll, 4000);   // filet de securite
    }
  }

  // ---- (2) Accroches composees mot-a-mot (these + CTA) ----
  function composeHeadline(el) {
    if (!el || el.getAttribute('data-vision-composed') === 'on') return;
    if (isLite || prefersReduce ||
        typeof gsap === 'undefined' || typeof SplitText === 'undefined') {
      return;   // repli : l'accroche reste revelee par son data-reveal
    }
    try {
      gsap.registerPlugin(SplitText);
      if (typeof ScrollTrigger !== 'undefined') gsap.registerPlugin(ScrollTrigger);
      el.setAttribute('data-vision-composed', 'on');
      var split = new SplitText(el, { type: 'words' });
      gsap.from(split.words, {
        opacity: 0,
        duration: 0.55,
        ease: 'power2.out',
        stagger: 0.055,
        delay: 0.12,
        scrollTrigger: {
          trigger: el,
          start: 'top 82%',
          once: true,
          onLeave: function () { gsap.set(split.words, { opacity: 1 }); },
          onLeaveBack: function () { gsap.set(split.words, { opacity: 1 }); }
        }
      });
      setTimeout(function () {       // filet de securite : visibilite finale
        if (split && split.words) gsap.set(split.words, { opacity: 1 });
      }, 4000);
    } catch (e) {
      if (window.console) console.warn('[xn] vision compose', e);
    }
  }

  function runCompose(tries) {
    tries = tries || 0;
    if (typeof gsap === 'undefined' && tries < 30) {
      setTimeout(function () { runCompose(tries + 1); }, 100);
      return;
    }
    composeHeadline(document.querySelector('.xn-vision-thesis__h2'));
    composeHeadline(document.querySelector('.xn-vision-cta__h2'));
    if (typeof ScrollTrigger !== 'undefined') ScrollTrigger.refresh();
  }
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () { runCompose(0); });
  } else {
    runCompose(0);
  }

  // ---- (3) Filet de securite : citation fondateur ----
  // La citation (.xn-founder__quote[data-founder-quote]) est revelee ligne-par-
  // ligne par le mecanisme existant founderQuote (SplitText lines, non modifie).
  // Ce filet force la visibilite finale si une ligne reste masquee (scroll
  // rapide, trigger non declenche) — l'ancre de confiance ne doit jamais
  // rester invisible. Ne re-anime rien : pose seulement l'etat final.
  setTimeout(function () {
    var fq = document.querySelector('[data-founder-quote]');
    if (!fq) return;
    var nodes = [fq].concat(Array.prototype.slice.call(fq.querySelectorAll('*')));
    nodes.forEach(function (n) {
      if (parseFloat(getComputedStyle(n).opacity || '1') < 0.9) {
        n.style.opacity = '1';
      }
    });
  }, 4500);
})();


/* === V13 STREAM A — VISION (cp2) ===========================================
   Effets scopés Vision V13. No-op hors page Vision. S'ajoute APRÈS initVisionV121
   (qui pose .is-traced sur [data-vision-fx] au scroll). Cette IIFE :
   (1) Force des reveals plus tôt sur les beats V13 (stance/constellation/atelier)
       — declenchement à 'top 95%' (au lieu du 'top 90%' global) pour éviter les
       viewports vides en scroll moyen.
   (2) Pose .is-traced sur le champ constellation pour tracer le trait et lancer
       le pulse via CSS uniquement.
   (3) Pose .is-traced sur la bande FRICTION du motif thèse pour qu'elle se
       trace au scroll quand la section thèse devient visible.
   Dégrade seul (no-gsap fallback, reduced-motion géré en CSS, filet 4s).
   ========================================================================== */
(function initVisionV13() {
  var hero = document.querySelector('.xn-vision-hero');
  if (!hero) return;                                       // hors page Vision : no-op
  var docEl = document.documentElement;
  if (docEl.getAttribute('data-vision-v13') === 'on') return;
  docEl.setAttribute('data-vision-v13', 'on');

  var prefersReduce = !!(window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  // ---- (1) Reveal tôt scopé pour les beats V13 ----
  // Les sections V13 (stance/constellation/atelier) déclenchent à 'top 95%'
  // — soit ~5% sous le pli — pour combler les viewports vides en scroll moyen.
  // On utilise ScrollTrigger si dispo, sinon IntersectionObserver, sinon
  // immédiat (filet de sécurité).
  var v13Beats = document.querySelectorAll(
    '.xn-vision-stance [data-reveal], ' +
    '.xn-vision-constellation [data-reveal], ' +
    '.xn-vision-atelier [data-reveal]'
  );

  function showEl(el) {
    if (typeof gsap !== 'undefined') {
      gsap.to(el, {
        opacity: 1,
        y: 0,
        duration: 0.7,
        ease: 'power2.out'
      });
    } else {
      el.style.opacity = '1';
      el.style.transform = 'translateY(0)';
    }
  }

  if (v13Beats.length) {
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
      v13Beats.forEach(function (el) {
        // Reset des reveals globaux : si déjà gsap.set par initReveals à
        // opacity:0/y:60, on ré-attache un trigger plus tôt à 'top 95%'.
        var rect = el.getBoundingClientRect();
        var alreadyVisible = rect.top < window.innerHeight * 0.95;
        if (alreadyVisible) {
          showEl(el);
        } else {
          ScrollTrigger.create({
            trigger: el,
            start: 'top 95%',
            once: true,
            onEnter: function () { showEl(el); }
          });
        }
      });
    } else if ('IntersectionObserver' in window) {
      var earlyObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            showEl(entry.target);
            earlyObs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.05, rootMargin: '0px 0px -5% 0px' });
      v13Beats.forEach(function (el) { earlyObs.observe(el); });
    } else {
      v13Beats.forEach(showEl);
    }
  }

  // ---- (2) Constellation : trace le trait + lance le pulse ----
  // .xn-vision-constellation__field porte déjà [data-vision-fx] → initVisionV121
  // pose .is-traced en entrée de viewport. La CSS prend le relais (transition
  // du stroke-dashoffset + animation du pulse). Aucun JS supplémentaire requis.

  // ---- (3) Motif FRICTION dans thèse : posé via [data-vision-friction-motif]
  // sur le conteneur, l'animation est portée par .is-traced sur la bande
  // ::before. On observe spécifiquement le motif pour le tracer tôt même si
  // le body de la thèse a déjà été révélé.
  var motif = document.querySelector('[data-vision-friction-motif]');
  if (motif) {
    if ('IntersectionObserver' in window) {
      var motifObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-traced');
            motifObs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.3, rootMargin: '0px 0px -5% 0px' });
      motifObs.observe(motif);
      // Cible aussi le step friction pour son ::before band
      var frictionStep = motif.querySelector('.xn-vision-thesis__motif-step--friction');
      if (frictionStep) {
        var frictObs = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-traced');
              frictObs.unobserve(entry.target);
            }
          });
        }, { threshold: 0.5, rootMargin: '0px 0px -5% 0px' });
        frictObs.observe(frictionStep);
      }
      // Filet 4s
      setTimeout(function () {
        motif.classList.add('is-traced');
        if (frictionStep) frictionStep.classList.add('is-traced');
      }, 4000);
    } else {
      motif.classList.add('is-traced');
    }
  }

  // ---- (4) Filet de sécurité : .xn-vision-stance__list reçoit .is-traced
  // pour révéler le filet sous le principe dominant.
  var stanceList = document.querySelector('.xn-vision-stance__list');
  if (stanceList) {
    if ('IntersectionObserver' in window) {
      var stanceObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-traced');
            stanceObs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.18, rootMargin: '0px 0px -5% 0px' });
      stanceObs.observe(stanceList);
      setTimeout(function () { stanceList.classList.add('is-traced'); }, 4000);
    } else {
      stanceList.classList.add('is-traced');
    }
  }

  // ---- (5) prefers-reduced-motion : pose états finals immédiatement ----
  if (prefersReduce) {
    v13Beats.forEach(function (el) {
      el.style.opacity = '1';
      el.style.transform = 'none';
    });
    document.querySelectorAll(
      '.xn-vision-stance__list, ' +
      '.xn-vision-constellation__field, ' +
      '[data-vision-friction-motif], ' +
      '.xn-vision-thesis__motif-step--friction'
    ).forEach(function (el) { el.classList.add('is-traced'); });
  }
})();

/* === V13 STREAM B — COMING SOON (cp4 motion) ===============================
   Effets scopes CS V13. No-op hors page Coming Soon. Mirroir du pattern
   initVisionV13 :
   (1) Reveals tot scopes pour les beats CS V13 (why/principles/constellation/
       anticipation/timeline/cta--v13) : declenche a 'top 95%' au lieu du
       'top 90%' global pour eviter les viewports vides en scroll moyen.
   (2) Pose .is-traced sur le champ constellation pour tracer le trait et
       lancer le pulse (CSS prend le relais).
   Degrade seul (no-gsap fallback, reduced-motion gere en CSS, filet 4s).
   ========================================================================== */
(function initCsV13() {
  var hero = document.querySelector('.xn-cs-hero--v13');
  if (!hero) return;                                       // hors page CS : no-op
  var docEl = document.documentElement;
  if (docEl.getAttribute('data-cs-v13') === 'on') return;
  docEl.setAttribute('data-cs-v13', 'on');

  var prefersReduce = !!(window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  // ---- (1) Reveal tot scope pour les beats CS V13 ----
  var v13Beats = document.querySelectorAll(
    '.xn-cs-why [data-reveal], ' +
    '.xn-cs-principles [data-reveal], ' +
    '.xn-cs-constellation [data-reveal], ' +
    '.xn-cs-anticipation [data-reveal], ' +
    '.xn-cs-timeline [data-reveal], ' +
    '.xn-cs-cta--v13 [data-reveal]'
  );

  function showEl(el) {
    if (typeof gsap !== 'undefined') {
      gsap.to(el, {
        opacity: 1,
        y: 0,
        duration: 0.7,
        ease: 'power2.out'
      });
    } else {
      el.style.opacity = '1';
      el.style.transform = 'translateY(0)';
    }
  }

  if (v13Beats.length) {
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
      v13Beats.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        var alreadyVisible = rect.top < window.innerHeight * 0.95;
        if (alreadyVisible) {
          showEl(el);
        } else {
          ScrollTrigger.create({
            trigger: el,
            start: 'top 95%',
            once: true,
            onEnter: function () { showEl(el); }
          });
        }
      });
    } else if ('IntersectionObserver' in window) {
      var earlyObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            showEl(entry.target);
            earlyObs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.05, rootMargin: '0px 0px -5% 0px' });
      v13Beats.forEach(function (el) { earlyObs.observe(el); });
    } else {
      v13Beats.forEach(showEl);
    }
  }

  // ---- (2) Constellation CS : trace le trait + lance le pulse ----
  // .xn-cs-constellation__field porte [data-cs-fx]. La CSS prend le relais
  // (transition du stroke-dashoffset + animation du pulse halo/dot).
  var csFxEls = document.querySelectorAll('[data-cs-fx]');
  function traceAll() {
    csFxEls.forEach(function (el) { el.classList.add('is-traced'); });
  }
  if (csFxEls.length) {
    if (!('IntersectionObserver' in window)) {
      traceAll();
    } else {
      var fxObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-traced');
            fxObs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.18, rootMargin: '0px 0px -5% 0px' });
      csFxEls.forEach(function (el) { fxObs.observe(el); });
      setTimeout(traceAll, 4000);   // filet de securite
    }
  }

  // ---- (3) prefers-reduced-motion : pose etats finals immediatement ----
  if (prefersReduce) {
    v13Beats.forEach(function (el) {
      el.style.opacity = '1';
      el.style.transform = 'none';
    });
    csFxEls.forEach(function (el) { el.classList.add('is-traced'); });
  }
})();


/* === V14.1 — MOTEUR ESTHÉTIQUE « Notre histoire » + « Prochainement » =======
   Brief V14.1 §3/§4/§6. Anti-tunnel : reveals orchestrés et VARIÉS par beat
   (signature char-compose / mot-à-mot / ligne-à-ligne / directionnel), champ
   d'étoiles VIVANT (tailles + halos + scintillement + parallaxe), nova orange
   au climax. Moteur PARTAGÉ par les 2 pages (cohérence = anti-patchwork §1),
   gaté par présence de page. NE TOUCHE PAS initReveals ni les IIFE home/produit.
   Robustesse (non négociable §3.4) :
     - reduced-motion / pas de GSAP / pas de ScrollTrigger -> RIEN n'est masqué,
       contenu visible statique (les états masqués sont posés EN JS uniquement).
     - SplitText absent -> repli reveal bloc entier.
     - filet de sécurité 4 s -> tout élément encore masqué redevient visible.
   ========================================================================== */
(function xnFxV141() {
  if (typeof document === 'undefined') return;
  var docEl = document.documentElement;

  var REDUCE = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var LITE   = docEl.classList.contains('xn-perf-lite');
  var G      = (typeof gsap !== 'undefined') ? gsap : null;
  var ST     = (typeof ScrollTrigger !== 'undefined') ? ScrollTrigger : null;
  var SPLIT  = (typeof SplitText !== 'undefined') ? SplitText : null;
  var ANIMATE = !!(G && ST && !REDUCE);          // peut-on animer en sécurité ?

  var SCRAMBLE = (typeof ScrambleTextPlugin !== 'undefined') ? ScrambleTextPlugin : null;

  if (G && ST) { try { G.registerPlugin(ST); } catch (e) {} }
  if (G && SPLIT) { try { G.registerPlugin(SPLIT); } catch (e) {} }
  if (G && SCRAMBLE) { try { G.registerPlugin(SCRAMBLE); } catch (e) {} }   // V14.2 — fx 'decode'

  var EASE = 'power3.out';
  var pending = [];                               // éléments masqués (filet 4 s)

  function inView(el) {
    var r = el.getBoundingClientRect();
    return r.top < (window.innerHeight || 0) * 0.92 && r.bottom > 0;
  }
  function onceEnter(el, cb, start) {
    if (!ST) { cb(); return; }
    if (inView(el)) { cb(); return; }
    ST.create({ trigger: el, start: start || 'top 86%', once: true, onEnter: cb });
  }

  /* ---- Étoiles vivantes (§6) : tailles variées + halos + scintillement ---- */
  function buildStars(fieldSel, starClass) {
    var fields = document.querySelectorAll(fieldSel);
    if (!fields.length) return;
    Array.prototype.forEach.call(fields, function (field) {
      var n = parseInt(field.getAttribute('data-nh-stars') || field.getAttribute('data-cs-stars'), 10) || 0;
      if (!n) return;
      if (LITE) n = Math.max(3, Math.round(n * 0.4));
      var frag = document.createDocumentFragment();
      for (var i = 0; i < n; i++) {
        var t = Math.random();
        var big = t > 0.86;
        // V14.1.2 (§4.2) — grandes etoiles = etoiles 4 branches (CSS clip-path),
        // donc nettement plus grandes pour etre lisibles ; petites = points fins.
        var size = big ? (9 + Math.random() * 7)
                       : (t > 0.5 ? (1.7 + Math.random() * 0.5) : (1.2 + Math.random() * 0.4));
        var op = big ? (0.66 + Math.random() * 0.3) : (0.26 + Math.random() * 0.34);
        var s = document.createElement('span');
        // V14.1.3 (B3) — NH : variété des étoiles notables (4 branches dominante +
        // astéroïdes --ast + orbes ronds --orb), au lieu de 4 branches identiques.
        // CS garde --lg (différenciation de la galaxie traitée en C4).
        var bvar = '';
        if (big) {
          if (starClass === 'xn-nh-star') { var bt = Math.random(); bvar = ' ' + starClass + (bt < 0.78 ? '--lg' : '--orb'); }  /* V14.2.1 (CP-C/1) — retrait --ast (difforme) : 4-branches dominante + orbe rond */
          else { bvar = ' ' + starClass + '--lg'; }
        }
        s.className = starClass + bvar;
        s.setAttribute('aria-hidden', 'true');
        s.style.setProperty('--x', (Math.random() * 100).toFixed(2) + '%');
        s.style.setProperty('--y', (Math.random() * 100).toFixed(2) + '%');
        s.style.setProperty('--s', size.toFixed(2) + 'px');
        s.style.setProperty('--o', op.toFixed(2));
        s.style.setProperty('--d', (-Math.random() * 6).toFixed(2) + 's');
        s.style.setProperty('--dur', (3.6 + Math.random() * 3.6).toFixed(2) + 's');
        // V14.1.3 (B3) — rotation plus variée (28-58deg) pour casser l'uniformité.
        if (big) s.style.setProperty('--rot', (28 + Math.random() * 30).toFixed(1) + 'deg');
        frag.appendChild(s);
      }
      field.appendChild(frag);
    });
  }

  /* ---- Parallaxe douce des champs (§3.2.6) : profondeur, jamais violent ---- */
  function parallaxFields(fieldSel) {
    if (!ANIMATE || LITE) return;
    var fields = document.querySelectorAll(fieldSel);
    Array.prototype.forEach.call(fields, function (field) {
      var f = parseFloat(field.getAttribute('data-nh-parallax') || field.getAttribute('data-cs-parallax')) || 0;
      if (!f) return;
      var amp = Math.min(20, f * 95);             // V14.1.2 (§4.2) parallaxe renforce (profondeur claire) ; l'overflow atmos -24% couvre les bords
      var section = field.parentElement || field;
      G.fromTo(field, { yPercent: -amp }, {
        yPercent: amp, ease: 'none',
        scrollTrigger: { trigger: section, start: 'top bottom', end: 'bottom top', scrub: true }
      });
    });
  }

  /* ---- Reveal d'un élément selon son traitement ---- */
  function hide(el, vars) { pending.push(el); G.set(el, vars); }

  function prepareSplit(el, type) {
    try {
      return new SplitText(el, { type: type, charsClass: 'char', wordsClass: 'word', linesClass: 'line' });
    } catch (e) { return null; }
  }

  /* ---- V14.2.1 (CP-B) — DECODE À EMPREINTE FIXE (A2) -------------------------------
     Remplace ScrambleText (qui, en police proportionnelle, faisait varier la largeur
     du texte → reflow/ressaut de lignes « trop hard », Osayan). Ici : chaque GLYPHE
     final reçoit une cellule inline-block dont la largeur est FIGÉE à la largeur du
     glyphe final mesurée. Les mots restent insécables (nowrap) → les sauts de ligne ne
     bougent jamais. Seules les glyphes changent EN PLACE (lettres aléatoires) puis se
     fixent de gauche à droite. Zéro reflow, zéro variation de largeur. Ponctuation et
     espaces : stables (jamais brouillés). Aucune dépendance plugin (rAF pur). --------- */
  var DECODE_GLYPHS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
  var DECODE_LETTER = /[A-Za-zÀ-ÿ]/;
  function randGlyph() { return DECODE_GLYPHS.charAt((Math.random() * DECODE_GLYPHS.length) | 0); }

  function buildDecodeCells(el) {
    var text = el.textContent;
    if (!text) return null;
    el.setAttribute('aria-label', text);              // nom accessible = texte final (pas le brouillage)
    el.textContent = '';
    var cells = [];
    var tokens = text.split(/(\s+)/);                 // conserve les séparateurs
    var frag = document.createDocumentFragment();
    for (var t = 0; t < tokens.length; t++) {
      var tok = tokens[t];
      if (tok === '') continue;
      if (/^\s+$/.test(tok)) { frag.appendChild(document.createTextNode(tok)); continue; }  // espace sécable
      var word = document.createElement('span');
      word.setAttribute('aria-hidden', 'true');
      word.style.display = 'inline-block';
      word.style.whiteSpace = 'nowrap';
      for (var i = 0; i < tok.length; i++) {
        var ch = tok.charAt(i);
        var cell = document.createElement('span');
        cell.textContent = ch;
        cell.style.display = 'inline-block';
        cell.style.textAlign = 'center';
        word.appendChild(cell);
        cells.push({ span: cell, ch: ch, scramble: DECODE_LETTER.test(ch) });
      }
      frag.appendChild(word);
    }
    el.appendChild(frag);
    // Fige la largeur de chaque cellule à sa largeur FINALE, puis pose l'état brouillé initial.
    for (var j = 0; j < cells.length; j++) {
      var w = cells[j].span.getBoundingClientRect().width;
      cells[j].span.style.width = w + 'px';
      cells[j].span.style.overflow = 'hidden';
      if (cells[j].scramble) cells[j].span.textContent = randGlyph();
    }
    return cells;
  }

  function runDecode(cells, durSec) {
    var n = cells.length;
    if (!n) return;
    var total = (durSec || 1.3) * 1000;
    var settleSpread = total * 0.72;                  // dernière lettre fixée à ~72 % du temps
    var rotWindow = total * 0.30;                     // fenêtre de rotation par lettre
    var t0 = null;
    function frame(ts) {
      if (t0 == null) t0 = ts;
      var t = ts - t0, done = 0;
      for (var i = 0; i < n; i++) {
        var c = cells[i];
        if (!c.scramble) { done++; continue; }
        var settleAt = (n > 1 ? i / (n - 1) : 0) * settleSpread + rotWindow;
        if (t >= settleAt) { if (c.span.textContent !== c.ch) c.span.textContent = c.ch; done++; }
        else { c.span.textContent = randGlyph(); }    // tourne en place
      }
      if (done < n) requestAnimationFrame(frame);
      else for (var k = 0; k < n; k++) cells[k].span.textContent = cells[k].ch;
    }
    requestAnimationFrame(frame);
  }

  function setupReveal(cfg) {
    var els = document.querySelectorAll(cfg.sel);
    if (!els.length) return;

    /* V14.2 — traitement de GROUPE 'stagger-rise' (grilles/cartes B2/B3) : un seul
       trigger, les items montent en cascade (un seul mouvement franc, pas de scrub). */
    if (cfg.fx === 'stagger-rise') {
      if (!ANIMATE) { if (cfg.on) cfg.on(els[0]); return; }   // visible (preHide n'a pas tourné)
      var goff = cfg.y != null ? cfg.y : 24;
      hide(els, { opacity: 0, y: goff });
      var trg = (cfg.groupTrigger && document.querySelector(cfg.groupTrigger)) || els[0];
      onceEnter(trg, function () {
        G.to(els, {
          opacity: 1, y: 0, duration: cfg.dur || 0.7, ease: EASE,
          stagger: cfg.stagger != null ? cfg.stagger : 0.08,
          onComplete: function () { G.set(els, { clearProps: 'transform' }); }
        });
        if (cfg.on) cfg.on(trg);
      }, cfg.start);
      return;
    }

    Array.prototype.forEach.call(els, function (el) {
      /* fx pilotés CSS (classe à l'entrée) — jamais masqués JS (dégradent seuls). */
      if (cfg.fx === 'draw') {
        onceEnter(el, function () { el.classList.add('is-drawn'); if (cfg.on) cfg.on(el); }, cfg.start);
        return;
      }
      // V14.2 — 'ignition' : point/zone qui s'embrase au scroll-in (CSS .is-ignited),
      // réservé à un climax (A4). Glow piloté CSS (guards reduced-motion/lite).
      if (cfg.fx === 'ignition') {
        onceEnter(el, function () { el.classList.add('is-ignited'); if (cfg.on) cfg.on(el); }, cfg.start);
        return;
      }
      if (!ANIMATE) { if (cfg.on) cfg.on(el); return; }   // visible par défaut

      /* V14.2.1 (CP-B) — 'decode' À EMPREINTE FIXE (A2) : cellules de largeur figée +
         rotation de glyphes EN PLACE (cf. buildDecodeCells/runDecode). Zéro reflow, zéro
         variation de largeur (corrige le ressaut de ScrambleText en police propor-
         tionnelle). L'élément est masqué (opacity 0, posé sync par preHide), construit en
         cellules déjà brouillées, puis paraît à l'entrée et se fixe de gauche à droite.
         Repli reduced-motion / no-GSAP : court-circuité en amont par le garde !ANIMATE
         (return visible) → texte final intact. */
      if (cfg.fx === 'decode') {
        var cells = buildDecodeCells(el);
        if (!cells) { G.set(el, { opacity: 1 }); if (cfg.on) cfg.on(el); return; }
        onceEnter(el, function () {
          G.set(el, { opacity: 1 });
          runDecode(cells, cfg.dur || 1.3);
          if (cfg.on) cfg.on(el);
        }, cfg.start);
        return;
      }

      var fx = cfg.fx, parts = null;
      if ((fx === 'chars' || fx === 'words' || fx === 'lines')) {
        if (!SPLIT) { fx = 'rise'; }
        else {
          var st = prepareSplit(el, fx === 'chars' ? 'chars,words' : fx);
          parts = st && (fx === 'chars' ? st.chars : fx === 'lines' ? st.lines : st.words);
          if (!parts || !parts.length) { fx = 'rise'; }
        }
      }

      /* V14.2.1 (CP-B) — reveals de LECTURE perceptibles : 'lines' 0.7 → 0.9 s (les
         entrées ligne-à-ligne étaient trop rapides / quasi invisibles, A3 surtout). */
      var dur = cfg.dur || (fx === 'chars' ? 0.85 : fx === 'lines' ? 0.9 : 0.8);
      var stg = cfg.stagger != null ? cfg.stagger : (fx === 'chars' ? 0.026 : fx === 'words' ? 0.05 : 0.09);
      var dly = cfg.delay || 0;
      var play;

      if (parts) {
        var fromV = (fx === 'chars')
          ? { opacity: 0, yPercent: 115 }
          : (fx === 'lines' ? { opacity: 0, y: 26 } : { opacity: 0, y: 16 });
        hide(parts, fromV);
        G.set(el, { opacity: 1 });   // V14.2 : conteneur préhidé sync → visible ; les parts portent le masque (anti-flash, pas de gris résiduel)
        play = function () {
          G.to(parts, {
            opacity: 1, y: 0, yPercent: 0, duration: dur, ease: EASE,
            stagger: stg, delay: dly,
            onComplete: function () { G.set(parts, { clearProps: 'transform' }); }
          });
        };
      } else {
        var off = cfg.y != null ? cfg.y : 32;       // amplitude généreuse §3.2.4
        var from = (fx === 'rise-left') ? { opacity: 0, x: -off }
                 : (fx === 'rise-right') ? { opacity: 0, x: off }
                 : { opacity: 0, y: off };
        hide(el, from);
        play = function () { G.to(el, { opacity: 1, x: 0, y: 0, duration: dur, ease: EASE, delay: dly }); };
      }

      onceEnter(el, function () { play(); if (cfg.on) cfg.on(el); }, cfg.start);
    });
  }

  /* ---- Filet de sécurité 4 s : rien ne reste masqué ---- */
  function safetyNet() {
    setTimeout(function () {
      pending.forEach(function (el) {
        try {
          var nodes = el.length != null ? el : [el];
          Array.prototype.forEach.call(nodes, function (n) {
            if (n && parseFloat(getComputedStyle(n).opacity || '1') < 0.1) {
              if (G) G.set(n, { opacity: 1, x: 0, y: 0, yPercent: 0, clearProps: 'transform' });
              else { n.style.opacity = '1'; n.style.transform = 'none'; }
            }
          });
        } catch (e) {}
      });
    }, 4000);
  }

  /* ---- Anti-flash V14.2 (§1.6/§5) : masquage SYNCHRONE à l'init, jamais différé.
     À l'exécution de l'IIFE (script `defer` → après parse du DOM), on pose opacity:0
     sur les cibles animées AVANT que boot() (fonts.ready) ne pose l'état précis +
     l'animation → zéro flash visible→masqué→visible. Gaté ANIMATE : no-JS / no-GSAP /
     reduced-motion → rien n'est masqué (contenu visible). Les fx pilotés CSS
     (draw/ignition) ne sont jamais masqués. ---- */
  function preHide(reveals) {
    reveals.forEach(function (cfg) {
      if (cfg.fx === 'draw' || cfg.fx === 'ignition') return;
      var els = document.querySelectorAll(cfg.sel);
      if (els.length) hide(els, { opacity: 0 });
    });
  }

  /* ---- Orchestration d'une page ---- */
  function runPage(cfg) {
    if (!document.querySelector(cfg.gate)) return;            // gate : no-op hors page
    if (docEl.getAttribute(cfg.flag) === 'on') return;        // idempotence
    docEl.setAttribute(cfg.flag, 'on');

    if (ANIMATE) { try { preHide(cfg.reveals); } catch (e) {} }   // V14.2 — masque sync (anti-flash)

    try { buildStars(cfg.starSel, cfg.starClass); } catch (e) {}
    parallaxFields(cfg.starSel);

    var booted = false;
    function boot() {
      if (booted) return;                                     // une seule fois (fonts.ready + filet timeout)
      booted = true;
      try { cfg.reveals.forEach(setupReveal); } catch (e) { if (window.console) console.warn('[xn] fx reveal', e); }
      try { if (cfg.specials) cfg.specials(); } catch (e) {}
      if (ST) ST.refresh();
      safetyNet();
    }
    if (ANIMATE && document.fonts && document.fonts.ready) {
      document.fonts.ready.then(boot);
      setTimeout(boot, 1500);                                 // repli si fonts.ready ne résout pas
    } else {
      boot();
    }
  }

  /* ---- V14.2.1 (CP-D) — A7 X-PARTICULES : échantillonnage le long du VRAI logo X
     (getPointAtLength sur les 3 paths cachés) + RÉPULSION souris PAR PARTICULE.
     Remplace l'ancienne parallaxe globale (plus de translate global du groupe). Injecte
     les <circle> dans [data-nh-xdots] (en écrasant le semis statique de repli). Répulsion :
     déplacement local par distance au curseur (coords SVG via getScreenCTM), retour
     élastique (lerp) en rAF ; seuls cx/cy bougent (la dérive/scintillement CSS vit sur le
     SVG/le scale → pas de conflit). OFF si !ANIMATE ; LITE → moins de particules + pas de
     souris ; pas de (pointer:fine) / tactile → pas de souris. ---- */
  function initNhXParticles() {
    var host = document.querySelector('[data-nh-xfield]');
    if (!host) return;
    var svg = host.querySelector('.xn-nh-xfield__svg');
    var dots = host.querySelector('[data-nh-xdots]');
    var paths = host.querySelectorAll('[data-nh-xpath]');
    if (!svg || !dots || !paths.length) return;
    if (!ANIMATE) return;                              // repli : semis statique conservé, visible

    var ok = true;
    Array.prototype.forEach.call(paths, function (p) { if (!p.getPointAtLength || !p.getTotalLength) ok = false; });
    if (!ok) return;                                   // pas de sampling → repli statique

    var perPath = LITE ? 7 : 14;
    var samples = [];
    Array.prototype.forEach.call(paths, function (p) {
      var L = p.getTotalLength();
      for (var i = 0; i < perPath; i++) {
        var t = (i + 0.5) / perPath + (Math.random() - 0.5) * (0.6 / perPath);
        t = t < 0 ? 0 : (t > 1 ? 1 : t);
        var pt = p.getPointAtLength(L * t);
        // v14.2.3 (#3) — jitter resserré (±2,5 → ±1) : les particules COLLENT au X.
        samples.push({ x: pt.x + (Math.random() - 0.5) * 2, y: pt.y + (Math.random() - 0.5) * 2 });
      }
    });

    var SVGNS = 'http://www.w3.org/2000/svg';
    while (dots.firstChild) dots.removeChild(dots.firstChild);   // écrase le semis statique
    var parts = [];
    var frag = document.createDocumentFragment();
    for (var s = 0; s < samples.length; s++) {
      var sm = samples[s];
      var big = Math.random() < 0.18;
      // V14.2.2 (CP-B) — rayons RÉDUITS (vraies étoiles, pas des pastilles pleines) :
      // grosses r ∈ [1.0 ; 1.5], petites r ∈ [0.4 ; 0.9] (au lieu de [1.8 ; 2.7] / [0.8 ; 1.7]).
      var r = big ? (1.0 + Math.random() * 0.5) : (0.4 + Math.random() * 0.5);
      var op = big ? (0.6 + Math.random() * 0.28) : (0.32 + Math.random() * 0.32);
      var c = document.createElementNS(SVGNS, 'circle');
      c.setAttribute('class', 'xn-nh-xp' + (big ? ' xn-nh-xp--big' : ''));
      c.setAttribute('cx', sm.x.toFixed(2));
      c.setAttribute('cy', sm.y.toFixed(2));
      c.setAttribute('r', r.toFixed(2));
      c.style.setProperty('--o', op.toFixed(2));
      c.style.setProperty('--d', (-Math.random() * 6).toFixed(2) + 's');
      c.style.setProperty('--dur', (3.8 + Math.random() * 2.6).toFixed(2) + 's');
      frag.appendChild(c);
      parts.push({ el: c, bx: sm.x, by: sm.y, dx: 0, dy: 0, big: big });
    }
    // V14.2.2 (CP-B) — plus de DOT ORANGE CENTRAL (ex-« Cursa » au croisement du X, qui
    // « faisait tache »). À la place : on TEINTE en orange 1 à 2 PETITES particules au hasard
    // (même taille que les blanches, « par-ci par-là »). Elles gardent le scintillement.
    var smalls = parts.filter(function (p) { return !p.big; });
    var want = smalls.length >= 2 ? 2 : smalls.length;
    for (var o = 0; o < want; o++) {
      var pick = smalls.splice(Math.floor(Math.random() * smalls.length), 1)[0];
      pick.el.setAttribute('class', pick.el.getAttribute('class') + ' xn-nh-xp--orange');
    }
    dots.appendChild(frag);

    if (LITE) return;
    if (!(window.matchMedia && window.matchMedia('(pointer: fine)').matches)) return;

    var RADIUS = 46, FORCE = 26;
    var active = true, raf = null, mx = null, my = null;
    if (ST) ST.create({ trigger: host, start: 'top bottom', end: 'bottom top',
      onToggle: function (self) { active = self.isActive; if (!active) { mx = my = null; ensure(); } } });

    function toSvg(clientX, clientY) {
      try {
        var ctm = svg.getScreenCTM(); if (!ctm) return null;
        var pt = svg.createSVGPoint(); pt.x = clientX; pt.y = clientY;
        return pt.matrixTransform(ctm.inverse());
      } catch (e) { return null; }
    }
    function step() {
      var moving = false;
      for (var i = 0; i < parts.length; i++) {
        var p = parts[i], tx = 0, ty = 0;
        if (mx != null) {
          var ddx = p.bx - mx, ddy = p.by - my, dist = Math.sqrt(ddx * ddx + ddy * ddy);
          if (dist < RADIUS && dist > 0.001) {
            var f = (1 - dist / RADIUS); f = f * f;
            tx = (ddx / dist) * FORCE * f; ty = (ddy / dist) * FORCE * f;
          }
        }
        p.dx += (tx - p.dx) * 0.12; p.dy += (ty - p.dy) * 0.12;
        if (Math.abs(p.dx) > 0.05 || Math.abs(p.dy) > 0.05 || Math.abs(tx - p.dx) > 0.05) moving = true;
        p.el.setAttribute('cx', (p.bx + p.dx).toFixed(2));
        p.el.setAttribute('cy', (p.by + p.dy).toFixed(2));
      }
      raf = moving ? requestAnimationFrame(step) : null;
    }
    function ensure() { if (!raf) raf = requestAnimationFrame(step); }
    document.addEventListener('mousemove', function (e) {
      if (!active) { mx = my = null; return; }
      var pt = toSvg(e.clientX, e.clientY); if (!pt) return;
      mx = pt.x; my = pt.y; ensure();
    }, { passive: true });
    document.addEventListener('mouseleave', function () { mx = my = null; ensure(); });
  }

  /* ---- V14.2.1 (CP-C/4) — A6 « L'exigence » : BALAYAGE de la règle millimétrique.
     Un marqueur orange descend la règle (--sweep 0→100 % posé en rAF — robuste, aucune
     dépendance au tween de variable CSS) et ALLUME les ticks séquentiellement (.is-lit) à
     son passage. `.is-seq` posé SYNCHRONE (dès le boot) → les ticks sont pilotés JS, pas
     de flash via la cascade .is-drawn. Gaté ANIMATE && !LITE (sinon repli CSS : ticks
     visibles statiques). Une seule passe, non-scrubbée. ---- */
  function initNhVscaleSweep() {
    var scale = document.querySelector('.xn-vision-method [data-nh-vscale]');
    if (!scale || !ANIMATE || LITE) return;
    var marker = scale.querySelector('.xn-nh-vscale__marker');
    var ticks = Array.prototype.slice.call(scale.querySelectorAll('.xn-nh-vscale__tick'));
    if (!ticks.length) return;
    var items = ticks.map(function (t) {
      var m = /--p:\s*([\d.]+)%/.exec(t.getAttribute('style') || '');
      return { el: t, p: m ? parseFloat(m[1]) : 0, lit: false };
    });
    scale.classList.add('is-seq');                     // pilotage JS dès le boot (anti-flash)
    onceEnter(scale, function () {
      var DUR = 1500, t0 = null;
      function frame(ts) {
        if (t0 == null) t0 = ts;
        var prog = (ts - t0) / DUR; if (prog > 1) prog = 1;
        var pct = prog * 100;
        if (marker) marker.style.setProperty('--sweep', pct.toFixed(1) + '%');
        for (var i = 0; i < items.length; i++) {
          if (!items[i].lit && items[i].p <= pct) { items[i].lit = true; items[i].el.classList.add('is-lit'); }
        }
        if (prog < 1) requestAnimationFrame(frame);
        else for (var k = 0; k < items.length; k++) items[k].el.classList.add('is-lit');
      }
      requestAnimationFrame(frame);
    }, 'top 86%');
  }

  /* ===================== V14.1 NH — NOTRE HISTOIRE ===================== */
  runPage({
    gate: '.xn-vision-hero',
    flag: 'data-nh-v141',
    starSel: '[data-nh-stars]',
    starClass: 'xn-nh-star',
    reveals: [
      /* A0 seuil — signature char-compose (1 des 2 effets « composé » du site) */
      { sel: '.xn-vision-hero .xn-nh-seuil__slogan', fx: 'chars', dur: 0.9, stagger: 0.03, start: 'top 92%' },
      { sel: '.xn-vision-hero .xn-nh-seuil__lede', fx: 'rise', delay: 0.55, start: 'top 92%' },
      { sel: '.xn-vision-hero .xn-nh-seuil__open', fx: 'rise', delay: 0.8, start: 'top 92%' },
      /* A1 naissance — lecture posée ligne-à-ligne + filet vertical + exergue mots */
      { sel: '.xn-vision-thesis .xn-nh-rule--v', fx: 'draw' },
      { sel: '.xn-vision-thesis .xn-nh-prose > p', fx: 'lines' },
      { sel: '.xn-vision-thesis .xn-nh-exergue', fx: 'words', dur: 0.7, stagger: 0.06 },
      /* A2 le nom — titre mot-à-mot + prose directionnelle (depuis la gauche) */
      { sel: '.xn-vision-stance .xn-nh-beat__title', fx: 'words', stagger: 0.07 },
      { sel: '.xn-vision-stance .xn-nh-prose > p', fx: 'lines' },
      { sel: '.xn-vision-stance .xn-nh-decode', fx: 'decode' },
      /* A3-A5 système — titres mots, prose reveal-lines, constellation + pull-quotes + exergue climax */
      { sel: '.xn-vision-constellation .xn-nh-beat__title', fx: 'words', stagger: 0.06 },
      /* V14.2.2 (CP-A) — A3/A4/A5 RECOMPOSÉS (R-CRÉA, brief §5) : la prose est segmentée en
         fragments scénarisés ; reveals RALENTIS (perceptibles) et séquencés par scroll (un
         fragment ≈ un beat de lecture), au lieu d'un fondu uniforme du paragraphe.
         A3 « La première étoile » : ancre → description → bridge → écho → cadre → éclaté → chute. */
      { sel: '.xn-nh-fs-kicker', fx: 'rise', y: 14 },
      { sel: '.xn-nh-fs-name', fx: 'words', stagger: 0.08, dur: 0.9 },
      { sel: '.xn-nh-fs-desc', fx: 'lines', dur: 1.0, y: 28, stagger: 0.1 },
      { sel: '.xn-nh-fs-bridge', fx: 'lines', dur: 1.0, y: 28, stagger: 0.1 },
      { sel: '.xn-vision-constellation .xn-nh-firststar__quote', fx: 'rise', y: 20, delay: 0.1 },
      { sel: '.xn-nh-fs-framing', fx: 'lines', dur: 0.95, y: 24, stagger: 0.1 },
      { sel: '.xn-nh-fs-seg', fx: 'stagger-rise', groupTrigger: '.xn-nh-fs-break', y: 22, stagger: 0.12, dur: 0.8 },
      { sel: '.xn-nh-fs-closer', fx: 'lines', dur: 0.95, y: 24, stagger: 0.1 },
      /* A4 « La révélation » (CLIMAX) : amorces, puis les termes déchiffrés (nova / X) qui se
         matérialisent, puis la phrase-relecture + l'exergue qui S'EMBRASENT (.is-ignited). */
      { sel: '.xn-nh-rv-amorce', fx: 'lines', dur: 1.0, y: 28, stagger: 0.1 },
      { sel: '.xn-nh-rv-term', fx: 'rise', y: 16, dur: 0.9 },
      { sel: '.xn-nh-rv-gloss', fx: 'lines', dur: 1.0, y: 26, stagger: 0.1 },
      { sel: '.xn-nh-rv-climax', fx: 'lines', dur: 1.0, y: 26, stagger: 0.1, on: function (el) { el.classList.add('is-ignited'); } },
      { sel: '.xn-nh-rv-chute', fx: 'lines', dur: 1.0, y: 26, stagger: 0.1 },
      { sel: '.xn-nh-rv-coda', fx: 'lines', dur: 1.0, y: 26, stagger: 0.1 },
      /* A5 « Le système » : fragments ÉCLATÉS révélés un à un pendant que la constellation
         (draw) allume ses étoiles ; écho de chute ; exergue ignité (cf. ci-dessus). */
      { sel: '.xn-nh-sy-frag', fx: 'lines', dur: 1.0, y: 28, stagger: 0.1 },
      { sel: '.xn-vision-constellation .xn-nh-constellation', fx: 'draw' },
      { sel: '.xn-vision-constellation .xn-nh-systeme__pull', fx: 'rise', y: 20 },
      { sel: '.xn-vision-constellation .xn-nh-exergue', fx: 'words', stagger: 0.06, on: function (el) { el.classList.add('is-ignited'); } },
      /* A6 exigence — règle VERTICALE (draw), prose reveal-lines, exergue mots */
      { sel: '.xn-vision-method .xn-nh-vscale__rule', fx: 'draw' },
      { sel: '.xn-vision-method .xn-nh-prose > p', fx: 'lines' },
      { sel: '.xn-vision-method .xn-nh-exergue', fx: 'words', stagger: 0.06 },
      /* A7 suite — CLÔTURE : titre mots, prose reveal-lines, accent mots, lien
         (X-étoiles : scintillement/dérive CSS + parallaxe souris en §specials) */
      { sel: '.xn-vision-cta .xn-nh-beat__title', fx: 'words', stagger: 0.07 },
      { sel: '.xn-vision-cta .xn-nh-prose > p', fx: 'lines' },
      { sel: '.xn-vision-cta .xn-nh-suite-accent', fx: 'words', stagger: 0.06 },
      { sel: '.xn-vision-cta .xn-nh-cta-wrap', fx: 'rise', delay: 0.15 }
      /* A8 signature RETIRÉE (founder supprimé V14.2) */
    ],
    specials: function () {
      /* Climax A4 : la nova s'embrase quand « La révélation » entre dans le viewport */
      var climax = document.querySelector('.xn-vision-constellation .xn-nh-beat__title--climax');
      var systeme = document.querySelector('.xn-nh-beat--systeme');
      if (climax && systeme) onceEnter(climax, function () { systeme.classList.add('is-climax-lit'); }, 'top 78%');
      /* V14.2.1 — A7 X-particules sur le vrai logo X + répulsion souris par particule
         (CP-D, remplace la parallaxe globale) ; A6 balayage de la règle millimétrique (CP-C). */
      try { initNhXParticles(); } catch (e) {}
      try { initNhVscaleSweep(); } catch (e) {}
    }
  });

  /* V14.1.3 (C1) — trajectoire en S : place les 5 jalons + le marqueur « Vous êtes
     ici » exactement sur la courbe (getPointAtLength), trace la portion « faite »
     jusqu'à ~75 %. Desktop (≥769px) ; mobile/no-JS → liste empilée (CSS de base).
     reduced-motion → courbe + marqueur statiques (tracé figé à 75 %, sans scroll). */
  function initCsTraj() {
    var traj = document.querySelector('[data-cs-traj]');
    if (!traj) return;
    var rail = traj.querySelector('.xn-cs2-traj__rail');
    var lit = traj.querySelector('.xn-cs2-traj__rail-lit');
    var svg = traj.querySelector('.xn-cs2-traj__svg');
    var here = traj.querySelector('[data-traj-here]');
    var steps = traj.querySelectorAll('.xn-cs2-traj__step');
    if (!rail || !lit || !svg || !steps.length || !rail.getPointAtLength) return;
    var vb = svg.viewBox.baseVal;
    // V14.2 (CP-E) — jalons RÉÉQUILIBRÉS (espacements ~0.19-0.24, aucun libellé qui
    // chevauche ; corrige l'entassement des 3 derniers à [0.78,0.89,0.965]).
    var FRACS = [0.05, 0.27, 0.50, 0.74, 0.93];    // idée, prototype, campagne(focal), production, expéditions
    // V14.2.2 (CP-D) — étoile « Vous êtes ici » == FIN DE L'ORANGE : HERE_FRAC === LIT_FRAC
    // (même fraction, même sens) → l'étoile tombe EXACTEMENT à la pointe de l'orange. Descendu
    // de 0.44 à 0.41 car 0.44 en longueur d'arc se LIT ~4/5 sur cette courbe en S ; à 0.41
    // l'œil lit ~3/4 entre prototype (0.27) et campagne (0.50). Orange NON scroll-dépendant
    // (cf. setupDraw : tracé one-shot, état stable = LIT_FRAC).
    var HERE_FRAC = 0.41, LIT_FRAC = 0.41;
    var mq = window.matchMedia('(min-width: 769px)');
    var drawST = null;
    var hasDrawn = false;   // v14.2.3 (#7) — verrou : orange tracé à LIT_FRAC ⇒ ne plus réinitialiser

    function place(el, frac) {
      var p = rail.getPointAtLength(rail.getTotalLength() * frac);
      el.style.left = (p.x / vb.width * 100) + '%';
      el.style.top = (p.y / vb.height * 100) + '%';
      return p;
    }
    function toCurve() {
      traj.classList.add('is-curve');
      for (var i = 0; i < steps.length; i++) {
        var f = FRACS[i] != null ? FRACS[i] : (i / (steps.length - 1));
        var p = place(steps[i], f);
        var above = p.y > vb.height * 0.5;          // courbe basse -> carte au-dessus
        steps[i].classList.toggle('is-above', above);
        steps[i].classList.toggle('is-below', !above);
      }
      if (here) place(here, HERE_FRAC);
    }
    function toStack() {
      traj.classList.remove('is-curve');
      for (var i = 0; i < steps.length; i++) {
        steps[i].style.left = ''; steps[i].style.top = '';
        steps[i].classList.remove('is-above', 'is-below');
      }
      if (here) { here.style.left = ''; here.style.top = ''; }
    }
    function setupDraw() {
      if (drawST) { drawST.kill(); drawST = null; }
      var L = lit.getTotalLength();
      lit.style.strokeDasharray = L;
      var target = L * (1 - LIT_FRAC);                  // état STABLE : orange tracé jusqu'à LIT_FRAC
      // v14.2.3 (#7) — FIABILISATION DÉTERMINISTE. L'orange doit TOUJOURS finir à
      // LIT_FRAC (== position exacte de l'étoile), quel que soit le scroll. Cause du
      // décalage persistant en V14.2.2 : apply() rejoué (resize/MQ) tuait+recréait le
      // tween en repartant de L (invisible) ; si le trigger « once » était déjà passé,
      // ou si ST.refresh() interrompait, l'orange restait court/caché → pointe et étoile
      // ne coïncidaient plus. Désormais : état de repos AUTORITAIRE posé directement dès
      // qu'on ne trace pas (no-anim / reduced-motion / déjà tracé / section déjà dépassée).
      var passed = traj.getBoundingClientRect().top < (window.innerHeight || 0) * 0.78;
      if (!ANIMATE || !ST || hasDrawn || passed) {
        lit.style.strokeDashoffset = target;
        hasDrawn = true;
        return;
      }
      // 1ère venue, section encore sous la ligne 78 % : effet de tracé one-shot PUIS
      // verrouillage définitif (onComplete) → aucune ré-init ne pourra le raccourcir.
      lit.style.strokeDashoffset = L;
      var tw = G.fromTo(lit, { strokeDashoffset: L }, {
        strokeDashoffset: target, ease: 'power2.out', duration: 1.5,
        scrollTrigger: { trigger: traj, start: 'top 78%', once: true },
        onComplete: function () { hasDrawn = true; lit.style.strokeDashoffset = target; }
      });
      drawST = tw.scrollTrigger || null;
    }
    function apply() {
      if (mq.matches) { toCurve(); setupDraw(); }
      else {
        toStack();
        lit.style.strokeDasharray = ''; lit.style.strokeDashoffset = '';
        if (drawST) { drawST.kill(); drawST = null; }
      }
      if (ST) ST.refresh();
    }
    apply();
    if (mq.addEventListener) mq.addEventListener('change', apply);
    else if (mq.addListener) mq.addListener(apply);
  }

  /* ===================== V14.1 CS — PROCHAINEMENT ===================== */
  runPage({
    gate: '.xn-cs-hero--v13',
    flag: 'data-cs-v141',
    starSel: '[data-cs-stars]',
    starClass: 'xn-cs2-star',
    reveals: [
      /* B0 hero — anticipation : « Cursa One. » char-compose (2e signature),
         countdown = focal 2, capture + méta en cascade */
      { sel: '.xn-cs-hero--v13 .xn-overline', fx: 'rise', start: 'top 96%' },
      { sel: '.xn-cs-hero__h1', fx: 'chars', dur: 0.9, stagger: 0.03, start: 'top 94%' },
      { sel: '.xn-cs2-hero__lead', fx: 'rise', delay: 0.4, start: 'top 94%' },
      { sel: '.xn-cs-hero--v13 .xn-cs2-hero__benefit', fx: 'rise', delay: 0.5, start: 'top 94%' },
      { sel: '.xn-cs-hero__countdown', fx: 'rise', delay: 0.55, start: 'top 94%' },
      { sel: '.xn-cs-hero__cta-wrap', fx: 'rise', delay: 0.6, start: 'top 96%' },
      { sel: '.xn-cs2-meta', fx: 'rise', delay: 0.85, start: 'top 98%' },
      /* B1 intro (Orion) — mythologie, lecture ligne-à-ligne */
      { sel: '.xn-cs-why .xn-overline', fx: 'rise' },
      { sel: '.xn-cs-why .xn-cs2-beat__title', fx: 'words', stagger: 0.06 },
      { sel: '.xn-cs-why .xn-cs2-prose', fx: 'lines' },
      { sel: '.xn-cs-why .xn-cs2-launchline', fx: 'draw' },
      /* V14.2.1 (CP-E) — B2 réseau métiers (tracé draw-on) + B3 paragraphes suivis (lines).
         Remplace les pilules (stagger) et le triptyque de cartes (stagger). */
      { sel: '.xn-cs-principles .xn-overline', fx: 'rise' },
      { sel: '.xn-cs-principles .xn-cs2-beat__title', fx: 'words', stagger: 0.05 },
      { sel: '.xn-cs-principles .xn-cs2-prose', fx: 'rise' },
      { sel: '.xn-cs2-metiers', fx: 'draw' },
      { sel: '.xn-cs2-graf', fx: 'lines' },
      /* B4 création — paternité + accent + CARNET de conception (vignettes draw-on, §R3) */
      { sel: '.xn-cs-anticipation .xn-overline', fx: 'rise' },
      { sel: '.xn-cs-anticipation .xn-cs2-beat__title', fx: 'words', stagger: 0.06 },
      { sel: '.xn-cs-anticipation .xn-cs2-prose', fx: 'rise' },
      { sel: '.xn-cs-anticipation .xn-cs2-anticipation-accent', fx: 'words', stagger: 0.06 },
      { sel: '.xn-cs2-vignette', fx: 'draw' },
      /* B5 galaxie — CONSTELLATION RETIRÉE (exclusive à Notre histoire) : transition texte */
      { sel: '.xn-cs-constellation .xn-overline', fx: 'rise' },
      { sel: '.xn-cs-constellation .xn-cs2-beat__title', fx: 'words', stagger: 0.06 },
      { sel: '.xn-cs-constellation .xn-cs2-prose', fx: 'rise' },
      /* B6/B7 trajectoire — rail + jalons en séquence */
      { sel: '.xn-cs-timeline .xn-overline', fx: 'rise' },
      { sel: '.xn-cs-timeline .xn-cs2-beat__title', fx: 'words', stagger: 0.05 },
      { sel: '.xn-cs-timeline .xn-cs2-prose', fx: 'rise' },
      { sel: '.xn-cs2-traj__step', fx: 'rise', y: 24 },
      /* B8 accès — climax conversion */
      { sel: '.xn-cs-cta .xn-overline', fx: 'rise' },
      { sel: '.xn-cs-cta .xn-cs2-beat__title', fx: 'words', stagger: 0.06 },
      { sel: '.xn-cs-cta .xn-cs2-prose', fx: 'rise' },
      { sel: '.xn-cs-cta .xn-form-card', fx: 'rise', delay: 0.1 },
      /* v14.2.3 (#8) — moment visuel « repère d'ouverture » : tracé au scroll (.is-drawn) */
      { sel: '.xn-cs-cta__mire', fx: 'draw' }
    ],
    specials: function () {
      /* V14.1.2 (§1.1) — bouton hero "Acces anticipe" -> scroll doux vers B8. */
      var ctaA = document.querySelector('.xn-cs-hero__cta[href="#acces-anticipe"]');
      var tgt = document.getElementById('acces-anticipe');
      if (ctaA && tgt) ctaA.addEventListener('click', function (e) {
        e.preventDefault();
        try { tgt.scrollIntoView({ behavior: REDUCE ? 'auto' : 'smooth', block: 'start' }); }
        catch (err) { tgt.scrollIntoView(); }
      });
      /* V14.1.3 (C1) — trajectoire en S : pose les jalons + marqueur sur la courbe
         et trace la portion « faite » jusqu'à ~75 % (remplace l'épine verticale). */
      try { initCsTraj(); } catch (e) { if (window.console) console.warn('[xn] traj', e); }
    }
  });

})();
